"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7718],{

/***/ 16983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ IconArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96937);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51776);



const IconArrow = ({ size =20 , color ="#19093A" , direction ="left" , isCaret =false , isCircle =false , className ="fill-violet_main_to_dark_purple_surface" , customClassName =""  })=>{
    const theme = (0,components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_1__/* .useSystemStore */ .m)((state)=>state.theme);
    switch(direction){
        case "left":
            className = "rotate-180";
            break;
        case "bottom":
            className = "rotate-90";
            break;
        case "up":
            className = "-rotate-90";
            break;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: className + " " + customClassName,
        width: size,
        height: size,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: isCaret ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M15.5397 11.2895L9.87974 5.63955C9.78677 5.54582 9.67617 5.47143 9.55431 5.42066C9.43246 5.36989 9.30175 5.34375 9.16974 5.34375C9.03773 5.34375 8.90702 5.36989 8.78516 5.42066C8.6633 5.47143 8.5527 5.54582 8.45974 5.63955C8.27349 5.82691 8.16895 6.08036 8.16895 6.34455C8.16895 6.60873 8.27349 6.86219 8.45974 7.04955L13.4097 12.0495L8.45974 16.9995C8.27349 17.1869 8.16895 17.4404 8.16895 17.7045C8.16895 17.9687 8.27349 18.2222 8.45974 18.4095C8.55235 18.504 8.6628 18.5792 8.78467 18.6307C8.90655 18.6822 9.03743 18.709 9.16974 18.7095C9.30204 18.709 9.43293 18.6822 9.5548 18.6307C9.67668 18.5792 9.78712 18.504 9.87974 18.4095L15.5397 12.7595C15.6412 12.6659 15.7223 12.5523 15.7777 12.4258C15.8331 12.2993 15.8617 12.1627 15.8617 12.0245C15.8617 11.8864 15.8331 11.7498 15.7777 11.6233C15.7223 11.4968 15.6412 11.3832 15.5397 11.2895Z",
            fill: theme == "dark" ? "#C29FEE" : color
        }) : isCircle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.86 12.5269L11.0867 8.76019C11.0247 8.6977 10.951 8.64811 10.8697 8.61426C10.7885 8.58041 10.7014 8.56299 10.6134 8.56299C10.5254 8.56299 10.4382 8.58041 10.357 8.61426C10.2757 8.64811 10.202 8.6977 10.14 8.76019C10.0159 8.8851 9.94617 9.05406 9.94617 9.23019C9.94617 9.40631 10.0159 9.57528 10.14 9.70019L13.44 13.0335L10.14 16.3335C10.0159 16.4584 9.94617 16.6274 9.94617 16.8035C9.94617 16.9796 10.0159 17.1486 10.14 17.2735C10.2018 17.3365 10.2754 17.3866 10.3567 17.421C10.4379 17.4553 10.5252 17.4732 10.6134 17.4735C10.7016 17.4732 10.7888 17.4553 10.8701 17.421C10.9513 17.3866 11.025 17.3365 11.0867 17.2735L14.86 13.5069C14.9277 13.4444 14.9817 13.3687 15.0186 13.2843C15.0556 13.2 15.0747 13.1089 15.0747 13.0169C15.0747 12.9248 15.0556 12.8337 15.0186 12.7494C14.9817 12.665 14.9277 12.5893 14.86 12.5269Z",
            fill: theme == "dark" ? "#C29FEE" : color
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M4.16272 9.1706L4.16277 9.0706L4.16291 9.0706C4.16298 9.0706 4.16306 9.0706 4.16313 9.0706L14.4442 9.07631L11.0153 5.64742C10.8416 5.47376 10.7441 5.23823 10.7441 4.99264C10.7441 4.74705 10.8416 4.51152 11.0153 4.33786C11.1889 4.1642 11.4245 4.06665 11.6701 4.06665C11.9156 4.06665 12.1512 4.16421 12.3248 4.33786L17.3322 9.3452L17.333 9.34606L17.333 9.34606C17.4174 9.43255 17.4841 9.53473 17.5293 9.64683C17.6226 9.87302 17.6226 10.1269 17.5293 10.3531C17.4841 10.4652 17.4174 10.5674 17.333 10.6539L17.3322 10.6548L17.3322 10.6548L12.3248 15.6621C12.1512 15.8358 11.9156 15.9333 11.6701 15.9333C11.4245 15.9333 11.1889 15.8358 11.0153 15.6621C10.8416 15.4884 10.7441 15.2529 10.7441 15.0073C10.7441 14.7617 10.8416 14.5262 11.0153 14.3525L14.4442 10.9236L4.16313 10.9294C4.16306 10.9294 4.16298 10.9294 4.16291 10.9294L4.16278 10.9294L4.16272 10.8294C4.05368 10.8298 3.94563 10.8087 3.8448 10.7671C3.74398 10.7256 3.65237 10.6645 3.57527 10.5874C3.49816 10.5103 3.43709 10.4187 3.39557 10.3179C3.35405 10.2171 3.3329 10.109 3.33335 9.99998M4.16272 9.1706C4.05368 9.17016 3.94563 9.1913 3.8448 9.23282C3.74398 9.27435 3.65237 9.33542 3.57527 9.41252C3.49816 9.48963 3.43709 9.58124 3.39557 9.68206C3.35405 9.78289 3.3329 9.89094 3.33335 9.99998M4.16272 9.1706L14.5442 9.17637L4.16272 9.1706ZM3.33335 9.99998L3.23335 9.99957C3.23335 9.9997 3.23334 9.99984 3.23334 9.99998C3.23334 10.0001 3.23335 10.0002 3.23335 10.0004L3.33335 9.99998Z",
            fill: theme == "dark" ? "#C29FEE" : color,
            stroke: color,
            strokeWidth: "0.2"
        })
    });
};


/***/ }),

/***/ 88038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ IconFilter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96937);


const IconFilter = ({ size =20 , color ="#19093A" , className ="fill-purple80_to_white"  })=>{
    const theme = (0,components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_1__/* .useSystemStore */ .m)((state)=>state.theme);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        // fill={color}
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Frame",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Vector",
                d: "M7 4H13.5M7 4C7 4.26522 6.89464 4.51957 6.70711 4.70711C6.51957 4.89464 6.26522 5 6 5C5.73478 5 5.48043 4.89464 5.29289 4.70711C5.10536 4.51957 5 4.26522 5 4M7 4C7 3.73478 6.89464 3.48043 6.70711 3.29289C6.51957 3.10536 6.26522 3 6 3C5.73478 3 5.48043 3.10536 5.29289 3.29289C5.10536 3.48043 5 3.73478 5 4M5 4H2.5M7 12H13.5M7 12C7 12.2652 6.89464 12.5196 6.70711 12.7071C6.51957 12.8946 6.26522 13 6 13C5.73478 13 5.48043 12.8946 5.29289 12.7071C5.10536 12.5196 5 12.2652 5 12M7 12C7 11.7348 6.89464 11.4804 6.70711 11.2929C6.51957 11.1054 6.26522 11 6 11C5.73478 11 5.48043 11.1054 5.29289 11.2929C5.10536 11.4804 5 11.7348 5 12M5 12H2.5M11 8H13.5M11 8C11 8.26522 10.8946 8.51957 10.7071 8.70711C10.5196 8.89464 10.2652 9 10 9C9.73478 9 9.48043 8.89464 9.29289 8.70711C9.10536 8.51957 9 8.26522 9 8M11 8C11 7.73478 10.8946 7.48043 10.7071 7.29289C10.5196 7.10536 10.2652 7 10 7C9.73478 7 9.48043 7.10536 9.29289 7.29289C9.10536 7.48043 9 7.73478 9 8M9 8H2.5",
                stroke: theme == "dark" ? "#C29FEE" : "#883CFF",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};


/***/ }),

/***/ 53117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HorizontalScroll; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var components_Icon_IconAngle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58682);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51776);
/* harmony import */ var components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96937);




const HorizontalScroll = ({ className ="" , paddingHorizontal =8 , children , useNavigation =true , top =0  })=>{
    const [theme] = (0,components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_3__/* .useSystemStore */ .m)((state)=>[
            state.theme
        ]);
    const isMobileView =  true && window.innerWidth < 768;
    const contentScrollRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const [currentScrollLeft, setCurrentScrollLeft] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    const [currentScrollWidth, setCurrentScrollWidth] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    const [currentContainerWidth, setCurrentContainerWidth] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (contentScrollRef.current) {
            setCurrentScrollLeft(contentScrollRef.current.scrollLeft);
            setCurrentScrollWidth(contentScrollRef.current.scrollWidth);
            setCurrentContainerWidth(contentScrollRef.current.clientWidth);
            contentScrollRef.current.addEventListener("scroll", ()=>{
                if (contentScrollRef.current) {
                    setCurrentScrollLeft(contentScrollRef.current.scrollLeft);
                }
            });
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentScrollRef,
                className: `${!isMobileView && `flex overflow-x-auto hide-scrollbar ${currentScrollLeft > 0 && "ml-50"} ${currentScrollLeft < currentScrollWidth - currentContainerWidth && "mr-44"}`} ${className}`,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: `flex items-center gap-0`,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "md:hidden block",
                            style: {
                                minWidth: paddingHorizontal,
                                width: paddingHorizontal
                            }
                        }),
                        children,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "md:hidden block",
                            style: {
                                minWidth: paddingHorizontal,
                                width: paddingHorizontal
                            }
                        })
                    ]
                })
            }),
            useNavigation && currentScrollLeft > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute -top-2 z-10",
                onClick: ()=>{
                    if (contentScrollRef.current) {
                        contentScrollRef.current.scrollBy({
                            left: -336,
                            behavior: "smooth"
                        });
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "p-2 rounded-full absolute bg-light_neutral10_to_dark_neutral50 flex justify-start items-center cursor-pointer -left-1",
                    style: {
                        top: 10
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "rounded-full border border-light_neutral10_to_dark_neutral50 w-36 h-36 flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconAngle__WEBPACK_IMPORTED_MODULE_1__/* .IconAngle */ .H, {
                            color: theme === "dark" ? "#FFFFFF" : "#3E3851"
                        })
                    })
                })
            }),
            useNavigation && currentScrollLeft < currentScrollWidth - currentContainerWidth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute -top-2 right-32 z-10",
                onClick: ()=>{
                    if (contentScrollRef.current) {
                        contentScrollRef.current.scrollBy({
                            left: 336,
                            behavior: "smooth"
                        });
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "p-2 rounded-full absolute bg-light_neutral10_to_dark_neutral50 flex justify-end items-center cursor-pointer",
                    style: {
                        top: 10
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "rounded-full border border-light_neutral10_to_dark_neutral50 w-36 h-36 flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconAngle__WEBPACK_IMPORTED_MODULE_1__/* .IconAngle */ .H, {
                            direction: "right",
                            color: theme === "dark" ? "#FFFFFF" : "#3E3851"
                        })
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 2859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ checkTawkTo; }
/* harmony export */ });
const toggleView = (currentUser)=>{
    const token = window?.localStorage?.getItem("token");
    if (token) {
        // console.log("start tawk to ");
        // @ts-ignore
        window.Tawk_API.showWidget();
        // @ts-ignore
        window.Tawk_API.start();
    } else {
        // console.log("shutdowning tawk to ");
        // @ts-ignore
        if (window.Tawk_API && typeof window.Tawk_API.shutdown === "function") {
            // console.log("==shutdown ok");
            // @ts-ignore
            window.Tawk_API.shutdown();
            // @ts-ignore
            window.Tawk_API.hideWidget();
        }
    }
};
const checkTawkTo = (currentUser)=>{
    // Ensure the Tawk object has initalized
    // @ts-ignore
    if (window.$_Tawk && window.$_Tawk.init) {
        toggleView(currentUser);
    } else {
        // If the Tawk object didn't initilize, use a differnt method of loading
        // @ts-ignore
        if (window.Tawk_API) {
            // @ts-ignore
            window.Tawk_API.onLoad = function() {
                toggleView(currentUser);
            };
        }
    }
};


/***/ }),

/***/ 86036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DU": function() { return /* binding */ getPrevLesson; },
/* harmony export */   "Kt": function() { return /* binding */ useCourseStore; },
/* harmony export */   "OA": function() { return /* binding */ getLessonNumberBySlug; },
/* harmony export */   "P_": function() { return /* binding */ getLessonIdBySlug; },
/* harmony export */   "Qm": function() { return /* binding */ getFirstUnfinishedLesson; },
/* harmony export */   "bR": function() { return /* binding */ getChapter; },
/* harmony export */   "cW": function() { return /* binding */ isHasWebinar; },
/* harmony export */   "tm": function() { return /* binding */ getNextLesson; }
/* harmony export */ });
/* unused harmony export courseTabItems */
/* harmony import */ var lib_object__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12582);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79010);


const courseTabItems = [
    "Konten Kelas",
    "Overview",
    "Rekomendasi Kursus Lainnya"
];
const useCourseStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set)=>({
        // state
        currentTab: courseTabItems[0],
        isLessonLoading: false,
        currentLesson: null,
        isPaywallShown: false,
        isLock: false,
        isNextLock: false,
        courseStatus: null,
        courseEnrollmentId: null,
        currentBundle: null,
        allCourse: null,
        currentCourse: null,
        showBundlePaywall: false,
        showSuccesBundle: false,
        showModalReview: false,
        bundleEnrollmentId: "",
        mandatoryCount: 0,
        showModalSubscribeBusiness: false,
        showModalSubscribeBusinessHR: false,
        showModalQuiz: false,
        // actions
        setCurrentTab (tab) {
            set({
                currentTab: tab
            });
        },
        setPaywallShown (b) {
            set({
                isPaywallShown: b
            });
        },
        setLock (b) {
            set({
                isLock: b
            });
        },
        setNextLock (b) {
            set({
                isNextLock: b
            });
        },
        setLessonLoading (isLoading = false) {
            set({
                isLessonLoading: isLoading
            });
        },
        setCurrentLesson (lesson) {
            set({
                currentLesson: lesson
            });
        },
        setAllCourse (course) {
            set({
                allCourse: course
            });
        },
        setCurrentCourse (course) {
            set({
                currentCourse: course
            });
        },
        setCourseStatus (courseStatus) {
            set({
                courseStatus: courseStatus
            });
        },
        setCourseEnrollmentId (id) {
            set({
                courseEnrollmentId: id
            });
        },
        setBundleEnrollmentId (id) {
            set({
                bundleEnrollmentId: id
            });
        },
        setBundle (currentBundle) {
            set({
                currentBundle
            });
        },
        setShowBundlePaywall (showBundlePaywall) {
            set({
                showBundlePaywall
            });
        },
        setShowSuccesBundle (showSuccesBundle) {
            set({
                showSuccesBundle
            });
        },
        setShowModalReview (showModalReview) {
            set({
                showModalReview
            });
        },
        setMandatoryCount (count) {
            set({
                mandatoryCount: count
            });
        },
        setShowModalSubscribeBusiness (showModal) {
            set({
                showModalSubscribeBusiness: showModal
            });
        },
        setShowModalSubscribeBusinessHR (showModal) {
            set({
                showModalSubscribeBusinessHR: showModal
            });
        },
        setShowModalQuiz (showModal) {
            set({
                showModalQuiz: showModal
            });
        }
    }));
const getChapter = (chapters, currentLessonSlug)=>{
    const chapter = chapters && chapters.length ? chapters.find((c)=>{
        const l = c.lessons?.find((l)=>l.slug == currentLessonSlug);
        return !!l;
    }) : [];
    return chapter;
};
const getNextLesson = (chapters, currentLessonSlug)=>{
    const sortedChapters = chapters && chapters.length ? (0,lib_object__WEBPACK_IMPORTED_MODULE_1__/* .ArrayObjectSortBy */ .Jy)(chapters, "number").map((c)=>{
        return {
            ...c,
            lessons: (0,lib_object__WEBPACK_IMPORTED_MODULE_1__/* .ArrayObjectSortBy */ .Jy)(c.lessons, "sort_order")
        };
    }) : [];
    let sortedLessons = [];
    sortedChapters.forEach((c)=>{
        c.lessons.forEach((l)=>sortedLessons.push({
                ...l,
                chapter: c.number
            }));
    });
    let nextLesson = null;
    for(let index = 0; index < sortedLessons.length - 1; index++){
        if (sortedLessons[index].slug == currentLessonSlug) {
            nextLesson = sortedLessons[index + 1];
            break;
        }
    }
    return nextLesson;
};
const getPrevLesson = (chapters, currentLessonSlug)=>{
    const sortedChapters = chapters && chapters.length ? (0,lib_object__WEBPACK_IMPORTED_MODULE_1__/* .ArrayObjectSortBy */ .Jy)(chapters, "number").map((c)=>{
        return {
            ...c,
            lessons: (0,lib_object__WEBPACK_IMPORTED_MODULE_1__/* .ArrayObjectSortBy */ .Jy)(c.lessons, "sort_order")
        };
    }) : [];
    let sortedLessons = [];
    sortedChapters.forEach((c)=>{
        c.lessons.forEach((l)=>sortedLessons.push({
                ...l,
                chapter: c.number
            }));
    });
    let prevLesson = null;
    for(let index = 1; index < sortedLessons.length; index++){
        if (sortedLessons[index].slug == currentLessonSlug) {
            prevLesson = sortedLessons[index - 1];
            break;
        }
    }
    return prevLesson;
};
const isHasWebinar = (chapters)=>{
    return chapters.some((c)=>c.lessons.some((l)=>l.type === "Webinar"));
};
const getFirstUnfinishedLesson = (courseStatus)=>{
    const sortedChapters = courseStatus.chapters && courseStatus.chapters.length ? (0,lib_object__WEBPACK_IMPORTED_MODULE_1__/* .ArrayObjectSortBy */ .Jy)(courseStatus.chapters, "number").map((c)=>{
        return {
            ...c,
            lessons: (0,lib_object__WEBPACK_IMPORTED_MODULE_1__/* .ArrayObjectSortBy */ .Jy)(c.lessons, "sort_order")
        };
    }) : [];
    let sortedLessons = [];
    sortedChapters.forEach((c)=>{
        c.lessons.forEach((l)=>sortedLessons.push({
                ...l
            }));
    });
    const unfinishedLesson = sortedLessons.find((l)=>l.progress[0]?.is_done == false);
    return unfinishedLesson;
};
// get lesson number from slug name
const getLessonNumberBySlug = (slug, courseStatus)=>{
    let allArray = [];
    if (courseStatus && courseStatus.chapters && courseStatus.chapters.length) {
        courseStatus.chapters.forEach((el)=>{
            el.lessons.forEach((a, i)=>{
                allArray.push({
                    number: el.number,
                    slug: a.slug
                });
            });
        });
    }
    if (allArray.length) {
        allArray = [
            ...allArray
        ].map((a, idx)=>{
            return {
                ...a,
                lesson_num: idx + 1
            };
        });
    }
    return allArray.find((a)=>a.slug == slug)?.lesson_num;
};
const getLessonIdBySlug = (chapters = [], slug)=>{
    // Iterate through the chapters array
    for (const chapter of chapters){
        // Iterate through the lessons in each chapter
        for (const lesson of chapter.lessons){
            // Check if the lesson's slug matches the given slug
            if (lesson.slug === slug) {
                // Return the ID of the matching lesson
                return {
                    lessonId: lesson.id,
                    chapterNum: chapter.number
                };
            }
        }
    }
    // If no matching lesson is found, return null or an appropriate value
    return null;
};


/***/ }),

/***/ 12337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__": function() { return /* binding */ useProcessTransaction; },
/* harmony export */   "gk": function() { return /* binding */ usePostPromoCode; },
/* harmony export */   "ph": function() { return /* binding */ useMyClassApi; },
/* harmony export */   "qy": function() { return /* binding */ useDeletePromoCode; },
/* harmony export */   "sC": function() { return /* binding */ useMyClassTransactionDetailApi; }
/* harmony export */ });
/* unused harmony exports useMyClassTransactionApi, useCreateTransactionApi, useGenerateCertificate, useDownloadCertificate, useStreamCertificate */
/* harmony import */ var lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49208);

const useMyClassApi = ()=>(0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("get", "/profile/my-class");
const useMyClassTransactionApi = ()=>useApi("get", "/transactions");
const useCreateTransactionApi = ()=>useApi("post", "/transactions");
const useMyClassTransactionDetailApi = (param)=>// @ts-ignore
    (0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("get", `/transactions/{id}${param ? param : ""}`);
const useProcessTransaction = ()=>(0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("post", "/transactions/process");
// error path
const usePostPromoCode = ()=>//@ts-ignore
    (0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("post", `/transactions/{id}/promocode`);
const useDeletePromoCode = (additionalKey)=>//@ts-ignore
    (0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("delete", `/transactions/${additionalKey}/promocode`);
//@ts-ignore
const useGenerateCertificate = (additionalKey)=>//@ts-ignore
    useApi("post", `/courses/${additionalKey}/certificate`);
const useDownloadCertificate = (additionalKey)=>//@ts-ignore
    useApi("get", `/courses/${additionalKey}/download-certificate`);
const useStreamCertificate = (additionalKey)=>//@ts-ignore
    useApi("get", `/courses/${additionalKey}/stream-certificate`);


/***/ }),

/***/ 37718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HomeTenant": function() { return /* binding */ HomeTenant; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(36734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(51776);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(33906);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(35824);
// EXTERNAL MODULE: ./src/components/PageHeader/PageHeaderDesktop.tsx + 10 modules
var PageHeaderDesktop = __webpack_require__(59504);
// EXTERNAL MODULE: ./src/modules/Auth/authStore.ts
var Auth_authStore = __webpack_require__(40474);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(56562);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 2 modules
var useTranslation = __webpack_require__(86880);
// EXTERNAL MODULE: ./src/modules/Explore/exploreApi.ts
var exploreApi = __webpack_require__(19077);
// EXTERNAL MODULE: ./src/lib/amplitude.ts + 1 modules
var amplitude = __webpack_require__(41272);
;// CONCATENATED MODULE: ./src/lib/useStateWithMemo.ts

function shallowEqual(objA, objB) {
    if (objA === objB) {
        return true;
    }
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
        return false;
    }
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    for (let key of keysA){
        if (objA[key] !== objB[key]) {
            return false;
        }
    }
    return true;
}
function useStateWithMemo(initialValue) {
    const [state, setState] = (0,react.useState)(initialValue);
    const memoizedSetState = (newValue)=>{
        if (!shallowEqual(newValue, state)) {
            setState(newValue);
        }
    };
    return [
        state,
        memoizedSetState
    ];
}

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(59574);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/components/Icon/IconFilter.tsx
var IconFilter = __webpack_require__(88038);
// EXTERNAL MODULE: ./src/components/ModalPortal/Modal.tsx + 1 modules
var Modal = __webpack_require__(54642);
// EXTERNAL MODULE: ./src/lib/device.ts
var device = __webpack_require__(59799);
// EXTERNAL MODULE: ./src/components/Icon/IconArrow.tsx
var IconArrow = __webpack_require__(16983);
// EXTERNAL MODULE: ./src/modules/Tenant/homeTenantApi.ts
var homeTenantApi = __webpack_require__(97684);
// EXTERNAL MODULE: ./src/components/Skeleton/Skeleton.tsx
var Skeleton = __webpack_require__(9978);
// EXTERNAL MODULE: ./src/modules/Course/courseStore.ts
var courseStore = __webpack_require__(86036);
// EXTERNAL MODULE: ./src/lib/host.ts
var host = __webpack_require__(35304);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(47601);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 88 modules
var swiper_esm = __webpack_require__(638);
// EXTERNAL MODULE: ./src/modules/Tenant/modalSectionStore.ts
var modalSectionStore = __webpack_require__(820);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(64078);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/InstantSearchBox/searchStore.ts
var searchStore = __webpack_require__(28755);
// EXTERNAL MODULE: ./src/lib/helper.ts
var helper = __webpack_require__(99601);
// EXTERNAL MODULE: ./src/modules/Business/Selection/cartStore.ts
var cartStore = __webpack_require__(13084);
// EXTERNAL MODULE: ./src/components/Icon/IconPlusCircle.tsx
var IconPlusCircle = __webpack_require__(38445);
// EXTERNAL MODULE: ./src/components/InteractiveAvatar/avatarStore.ts
var avatarStore = __webpack_require__(43085);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(67832);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/Card/CardCourseSectionMobile.tsx












const VideoJS = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(2544), __webpack_require__.e(9412), __webpack_require__.e(8289), __webpack_require__.e(1239), __webpack_require__.e(3756)]).then(__webpack_require__.bind(__webpack_require__, 57818)).then((mod)=>mod.VideoJS), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57818)
            ]
    },
    ssr: false
});
const CardCourseSectionMobile = ({ isUncheck =false , isHide =false , className ="" , isRow =false , isMyClass =false , isSquare =false , tracker , wrapClass ="" , isRecommendPage =false , onClickFunction , isModal =false , ...props })=>{
    const [chapters, setChapters] = (0,react.useState)([]);
    const [countLesson, setCountLesson] = (0,react.useState)(0);
    const [isLoading, setLoading] = (0,react.useState)(false);
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const isB2B = (0,host/* useIsTenant */.we)() || (0,host/* useIsSubdomain */.Do)();
    const isBusiness = !isB2B;
    (0,react.useEffect)(()=>{
        if (isRow && props?.chapters && props?.chapters.length) {
            setLoading(true);
            const newChapters = props?.chapters.map((el)=>{
                const allLesson = el?.lessons && el?.lessons.length ? el?.lessons.map((items)=>({
                        image: props?.image_cover_url,
                        course_slug: props.slug,
                        ...items
                    })) : [];
                return {
                    name: el.name,
                    image: props?.image_cover_url,
                    lessons: allLesson
                };
            });
            let counting = props?.chapters.flatMap((el)=>el?.lessons && el?.lessons.length);
            setCountLesson(counting.length);
            setChapters(newChapters);
            setLoading(false);
        }
    }, [
        props.chapters,
        isRow
    ]);
    const events = (0,react.useMemo)(()=>({
            event: "course_hover_a",
            property: {
                course_name: props?.name ?? "",
                course_slug: props?.slug ?? "",
                section_name: props?.sectionName ?? "",
                institution_name: props?.institution_name ?? props.institution?.name ?? "",
                index: props?.index ?? 0,
                page: `B2B Homepage`
            }
        }), [
        props
    ]);
    const [isHovering, setIsHovered] = (0,react.useState)(null);
    const [videoURL, setVideoURL] = (0,react.useState)("");
    const [timeout, setModalTimeout] = (0,react.useState)(null);
    const [videoTimeout, setVideoTimeout] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        setVideoURL(props?.hover_content_url);
    }, [
        isHovering
    ]);
    const mouseEnterHandler = (0,react.useCallback)(()=>{
        timeout && clearTimeout(timeout);
        videoTimeout && clearTimeout(timeout);
        setModalTimeout(setTimeout(()=>{
            (0,amplitude/* trackEventGTM */.hk)({
                ...events
            });
            (0,amplitude/* trackEventGA */.w7)({
                ...events
            });
            (0,amplitude/* trackEventGTM */.hk)({
                ...events
            });
            (0,amplitude/* trackEventGA */.w7)({
                ...events
            });
        }, 3000));
        setVideoTimeout(setTimeout(()=>{
            setIsHovered(isHide ? false : true);
        }, 500));
    }, [
        events,
        isHide,
        timeout,
        videoTimeout
    ]);
    const mouseLeaveHandler = (0,react.useCallback)(()=>{
        timeout && clearTimeout(timeout);
        videoTimeout && clearTimeout(videoTimeout);
        setIsHovered(false);
    }, [
        timeout,
        videoTimeout
    ]);
    const router = (0,next_router.useRouter)();
    const hasBusinessCourse = typeof router.query.hasBusinessCourse == "string" ? router.query.hasBusinessCourse : "false";
    const { loginState , currentUser  } = (0,Auth_authStore/* useAuthStore */.t)((state)=>({
            loginState: state.loginState,
            currentUser: state.currentUser
        }));
    const tenantJpTracker = currentUser?.tenant !== undefined && [
        "ppsdmaparatur",
        "menpan",
        "wonderfullearning",
        "kemkes",
        "tapinkab",
        "bssn",
        "bkpsdm-bekasikota",
        // "maluku-gate",
        // "trenggalekkab",
        "bpsdm-sumbar",
        "bpsdm-sulsel",
        "bpsdm-jambi",
        "bpsdmdki",
        // "jambikota",
        // "muarojambikab",
        // "pesawarankab",
        "batam",
        "pusdiklat-komdigi",
        "pusdiklat-kemenkeu",
        "kemenperin"
    ].includes((currentUser?.tenant)?.slug) || [
        "ppsdmaparatur",
        "menpan",
        "wonderfullearning",
        "kemkes",
        "tapinkab",
        "bssn",
        "bkpsdm-bekasikota",
        // "maluku-gate",
        // "trenggalekkab",
        "bpsdm-sumbar",
        "bpsdm-sulsel",
        "bpsdm-jambi",
        "bpsdmdki",
        // "jambikota",
        // "muarojambikab",
        // "pesawarankab",
        "batam",
        "pusdiklat-komdigi",
        "pusdiklat-kemenkeu",
        "kemenperin"
    ].includes(currentUser?.referral);
    const gaiaMultipleAccess = currentUser?.tenant !== undefined && [
        "gaia",
        "mega-insurance-moodle",
        "pupuk-indonesia"
    ].includes((currentUser?.tenant)?.slug) || [
        "gaia",
        "mega-insurance-moodle",
        "pupuk-indonesia"
    ].includes(currentUser?.referral);
    const updateCart = (0,cartStore/* useCartStore */.x)((state)=>state.updateCart);
    let content = (0,react.useCallback)(()=>videoURL ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoJS, {
            isHovering: isHovering,
            url: videoURL,
            handleInterrupt: ()=>{}
        }) : null, [
        videoURL,
        isHovering
    ]);
    const [isHoveringGaia, setIsHoveringGaia] = (0,react.useState)(false);
    const { setIsCourseTranscript , setCourseTranscript  } = (0,avatarStore/* useAvatarStore */.z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (!isRow ? "cursor-pointer" : "") + " relative h-full w-full",
        onClick: onClickFunction ? onClickFunction : ()=>{
            if (!isRow) {
                if (props.onSelect) {
                    updateCart(props);
                } else {
                    router.push(loginState == "LOGIN" ? isRecommendPage ? {
                        pathname: "/r/[page]",
                        query: {
                            page: `/course/${props.slug}`
                        }
                    } : {
                        pathname: "/course/[courseSlug]",
                        query: {
                            courseSlug: props?.slug
                        }
                    } : {
                        pathname: "/login",
                        query: {
                            url: encodeURIComponent(`/course/${props?.slug}`)
                        }
                    });
                }
            }
            if (tracker) {
                (0,amplitude/* trackEventGTM */.hk)(tracker);
                (0,amplitude/* trackEventGA */.w7)(tracker);
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: `flex gap-8 h-fit ${isRow ? "flex-col w-full md:flex-row" : "flex-col"}`,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `relative cursor-pointer overflow-hidden aspect-[16/9]`,
                onMouseEnter: mouseEnterHandler,
                onMouseLeave: mouseLeaveHandler,
                onClick: ()=>{
                    if (isRow) {
                        router.push(loginState == "LOGIN" ? {
                            pathname: "/course/[courseSlug]",
                            query: {
                                courseSlug: props?.slug
                            }
                        } : {
                            pathname: "/login",
                            query: {
                                url: encodeURIComponent(`/course/${props?.slug}`)
                            }
                        });
                    }
                    if (tracker) {
                        (0,amplitude/* trackEventGTM */.hk)(tracker);
                        (0,amplitude/* trackEventGA */.w7)(tracker);
                    }
                },
                children: [
                    (!isHovering || !props?.hover_content_url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: props.image_cover_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            priority: true,
                            fetchPriority: "high",
                            alt: props.name,
                            src: props.image_cover_url,
                            width: 305,
                            height: 150,
                            "data-testid": "card-featured_cover",
                            className: `object-cover w-full h-full object-center ${isHovering ? "" : isSquare ? "" : "rounded-8"}`
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `bg-neutral-20 w-full aspect-[16/9] ${isRow ? "h-full" : "md:full"} ${isSquare ? "" : "rounded-8"}`
                        })
                    }),
                    isBusiness && router.pathname == "/pilih-kursus" && !isUncheck && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 w-full h-full flex justify-end items-start p-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPlusCircle/* IconPlusCircle */.O, {})
                    }),
                    isHovering && props?.hover_content_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full h-full",
                        children: content()
                    }),
                    isHide && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 bg-[#00000099] w-full h-full flex justify-center items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-b1 font-black text-white",
                            children: "Khusus goKampus Business"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute bottom-0 w-full h-full px-[8px] py-[6px] bg-gradient-to-t from-[#000] to-transparent rounded-[8px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "w-[162px] absolute bottom-4 text-[#fff] text-[14px] font-[500] overflow-hidden text-ellipsis whitespace-pre-wrap",
                            style: {
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden"
                            },
                            children: props?.name
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Card_CardCourseSectionMobile = (CardCourseSectionMobile);

;// CONCATENATED MODULE: ./src/modules/Tenant/Section.tsx










// import CardCourseWithLesson from "components/Card/CardCourseWithLesson";








const CardCourseWithLesson = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 97216)).then((mod)=>mod.default), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(97216)
            ]
    },
    ssr: false
});
swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* FreeMode */.Rv
]);
const Section = ({ isPopular =false , tag , title , section , sort ="" , emoji , data , isNeedFetchCourse =true , isHidden =null , id , ...props })=>{
    // @ts-ignore
    const getCourses = (0,homeTenantApi/* useGetCoursesByTenantSlug */.HL)();
    const [isLoading, setIsLoading] = (0,react.useState)(true);
    const currentUser = (0,Auth_authStore/* useAuthStore */.t)((state)=>state.currentUser);
    const [currData, setCurrData] = (0,react.useState)([]);
    const [page, setPage] = (0,react.useState)(1);
    const [totalData, setTotalData] = (0,react.useState)(data?.length ?? 0);
    const [noMoreData, setNoMoreData] = (0,react.useState)(false);
    const [shuffledData, setShuffledData] = (0,react.useState)(null);
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const { t: tr  } = (0,useTranslation/* default */.Z)("tags");
    const [setSelectedTitle, isShow, setIsShow, setDataSection, setLoading] = (0,modalSectionStore/* useModalSectionStore */.y)((state)=>[
            state.setSelectedTitle,
            state.isShow,
            state.setIsShow,
            state.setDataSection,
            state.setLoading
        ]);
    const { popularCourse  } = (0,searchStore/* useSearchStore */.R)();
    const [limit, setLimit] = (0,react.useState)(isPopular ? popularCourse?.length : 10);
    const { mandatoryCount , setMandatoryCount  } = (0,courseStore/* useCourseStore */.Kt)((s)=>({
            mandatoryCount: s.mandatoryCount,
            setMandatoryCount: s.setMandatoryCount
        }));
    const getSectionDetail = (0,homeTenantApi/* useGetSectionDetail */.YT)();
    (0,react.useEffect)(()=>{
        if (isPopular) {
            setCurrData(popularCourse);
        } else {
            setCurrData(data ? data : []);
        }
    // console.log(currData);
    }, [
        data
    ]);
    const referralCode = (0,helper/* getCookie */.ej)("ref_code_gk") && (0,helper/* getCookie */.ej)("ref_code_gk") !== "null" ? (0,helper/* getCookie */.ej)("ref_code_gk") :  true ? new URLSearchParams(window.location.search).get("referral") : 0;
    const fetchMyCourses = ()=>{
        /// Prevent API to fetch moodle subdomain since tenant isn't on the BE
        const noTenantSubdomain = [
            "moodle"
        ];
        const currentSlug = currentUser?.referral ?? (0,host/* getSubDomain */.ZC)(window.location.hostname);
        if (!noTenantSubdomain.includes(currentSlug)) {
            getCourses.doFetch(sort ? {
                slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : // ? referralCode
                currentSlug,
                limit,
                sort: sort ?? "",
                // @ts-ignore
                page,
                "tags[]": tag == "newest" ? null : tag
            } : {
                slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : // ? referralCode
                currentSlug,
                limit,
                page,
                "tags[]": tag == "newest" ? null : tag
            }, {
                onSuccess (data) {
                    // if (sort) {
                    // console.log(data);
                    // }
                    const uniqueData = data?.data.filter((item)=>{
                        return !currData.some((existingItem)=>existingItem.id === item.id);
                    });
                    // setCurrData((prev) => [...prev, ...uniqueData]);
                    if (isPopular) {
                        setCurrData(popularCourse);
                    } else {
                        setCurrData(data?.data);
                    }
                    // if (data.meta.current_page === data.meta.last_page) {
                    //   setTotalData([...currData, ...uniqueData].length);
                    // } else {
                    //   setTotalData(data.meta.total);
                    // }
                    setTotalData(data.meta.total);
                    const mandatories = data?.course_mandatories_count;
                    // const mandatories = 0
                    setMandatoryCount(mandatories);
                    setIsLoading(false);
                },
                onError (e) {
                    setTotalData(0);
                    setIsLoading(false);
                }
            });
        }
    };
    const fetchSectionDetail = ()=>{
        const currentSlug = currentUser?.referral ?? (0,host/* getSubDomain */.ZC)(window.location.hostname);
        if (typeof id === "number") {
            // section mandatory by id
            getSectionDetail.doFetch({
                slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : // ? referralCode
                currentUser?.referral,
                section: id
            }, {
                onSuccess (data) {
                    setDataSection(data?.data[0].tag.courses);
                    setLoading(false);
                }
            });
        } else if (typeof id === "string" && id == "default" && currentSlug) {
            // section sorting by tag
            getCourses.doFetch({
                slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : // ? referralCode
                currentSlug,
                // @ts-ignore
                "tags[]": tag
            }, {
                onSuccess (data) {
                    setDataSection(data?.data);
                    setLoading(false);
                }
            });
        } else if (!id) {
            // section kursus terbaru
            setDataSection(currData);
            setLoading(false);
        }
    };
    // console.log(currData);
    let itemCounts = page * limit;
    if (page > 1) itemCounts = totalData;
    const displayedItems = [
        ...currData
    ].slice(0, itemCounts);
    const renderCount = (0,react.useRef)(0);
    const loginState = (0,Auth_authStore/* useAuthStore */.t)((state)=>state.loginState);
    // useEffect(() => {
    //   /// Nonaktif karena tidak jalan di kemenperin prod
    //   // renderCount.current = renderCount.current + 1;
    //   // if (renderCount.current === 2) {
    //   //   setLimit(9);
    //   //   return;
    //   // }
    //   // No need fetch API
    //   if (!isNeedFetchCourse) {
    //     setIsLoading(false);
    //     return;
    //   }
    //   // Fetch API
    //   if (!noMoreData) {
    //     fetchMyCourses();
    //   }
    // }, [tag, currentUser, page]);
    (0,react.useEffect)(()=>{
        if (isPopular) {
            setCurrData(popularCourse);
        } else {
            if (data && data.length) {
                setCurrData(data);
                setTotalData(data?.length);
                setIsLoading(false);
            } else {
                fetchMyCourses();
                setIsLoading(false);
            }
        }
    }, [
        data,
        referralCode
    ]);
    // useEffect(() => {
    //   setPage(1);
    // }, [limit]);
    const showLess = displayedItems.length === totalData;
    const buttonHandler = (type)=>{
        (0,amplitude/* trackEventGTM */.hk)({
            event: "b2b_homepage_course_more_a",
            property: {
                category_name: tag ?? t(title) ?? "",
                button_type: type,
                section
            }
        });
        (0,amplitude/* trackEventGA */.w7)({
            event: "b2b_homepage_course_more_a",
            property: {
                category_name: tag ?? t(title) ?? "",
                button_type: type,
                section
            }
        });
        (0,amplitude/* trackEventGTM */.hk)({
            event: "b2b_homepage_course_more_a",
            property: {
                category_name: tag ?? t(title) ?? "",
                button_type: type,
                section
            }
        });
        (0,amplitude/* trackEventGA */.w7)({
            event: "b2b_homepage_course_more_a",
            property: {
                category_name: tag ?? t(title) ?? "",
                button_type: type,
                section
            }
        });
    // if (noMoreData && showLess) {
    //   setLimit(3);
    //   setPage(1);
    //   return;
    // }
    // setPage((p) => p + 1);
    };
    const isDesktopView =  true && window.screen.width >= 480;
    // useEffect(() => {
    //   /// Prevent data not passed in props
    //   if (currData.length === 0) {
    //     setNoMoreData(false);
    //   } else {
    //     setNoMoreData(currData.length >= totalData);
    //   }
    // }, [currData]);
    const settings = {
        className: "swiper-customized",
        freeMode: isDesktopView,
        spaceBetween: 12,
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1.2,
                slidesPerGroup: 1.2,
                spaceBetween: 12
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 12
            },
            // when window width is >= 912px
            1200: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 12
            }
        }
    };
    const isMobile =  true && window.innerWidth < 768;
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        if (currData.length > 0) {
            const shuffled = [
                ...currData
            ].sort(()=>Math.random() - 0.5);
            setShuffledData(shuffled);
        }
    }, [
        currData
    ]);
    const showedItems = shuffledData?.slice(0, 3);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-32 relative",
        children: [
            // isLoading ? (
            //   <SkeletonWrapper className="grid grid-cols-1">
            //     {[1].map((el) => (
            //       <SkeletonRect className="h-50 rounded-8 w-full" />
            //     ))}
            //   </SkeletonWrapper>
            // ) :
            currData && currData.length >= 1 ? // <h2
            //   // onClick={() => buttonHandler("Section Title")}
            //   className="text-neutral-80 text-h4 font-medium mb-16 px-16 md:px-0"
            // >
            //   {tag == "newest"
            //     ? t(title)
            //     : tag
            //     ? tr(tag) ?? ""
            //     : data
            //     ? title ?? ""
            //     : tag ?? ""}
            // </h2>
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between md:justify-start gap-8 pr-16 pb-20 pt-8 xl-max:pb-12 xl-max:pt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-neutral80_to_dark10 text-h4 font-medium " + (currData && currData.length > 3 ? "cursor-pointer" : ""),
                        onClick: ()=>{
                            if (currData && currData.length > 3) {
                                if (loginState == "LOGIN") {
                                    if (!isMobile) {
                                        setSelectedTitle(tag == "newest" ? t(title) : data ? title ?? "" : tag ? tr(tag) ?? "" : tag);
                                        setIsShow(!isShow);
                                        fetchSectionDetail();
                                    } else {
                                        const ids = !id ? "newest" : id !== "default" ? id : "default";
                                        if (currData && currData.length > 3) {
                                            router.push({
                                                pathname: "/section-detail/[id]",
                                                query: ids !== "default" && !isPopular ? {
                                                    id: ids,
                                                    section: "custom"
                                                } : isPopular ? {
                                                    id: ids,
                                                    section: "popular"
                                                } : {
                                                    id: ids,
                                                    section: "custom",
                                                    tag: tag
                                                }
                                            });
                                        }
                                    }
                                } else {
                                    if (currData && currData.length > 3) {
                                        router.push({
                                            pathname: "/login"
                                        });
                                    }
                                }
                            }
                        },
                        children: tag == "newest" ? t(title) : data ? title ?? "" : tag ? tr(tag) ?? "" : tag
                    }),
                    currData && currData.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-4 text-b2 font-medium cursor-pointer text-violet_main_to_dark_purple_surface",
                        onClick: ()=>{
                            if (loginState == "LOGIN") {
                                if (!isMobile) {
                                    setSelectedTitle(tag == "newest" ? t(title) : tag ? tr(tag) ?? "" : data ? title ?? "" : tag ?? "");
                                    setIsShow(!isShow);
                                    fetchSectionDetail();
                                } else {
                                    const ids = !id ? "newest" : id !== "default" ? id : "default";
                                    router.push({
                                        pathname: "/section-detail/[id]",
                                        query: ids !== "default" && !isPopular ? {
                                            id: ids,
                                            section: "custom"
                                        } : isPopular ? {
                                            id: ids,
                                            section: "popular"
                                        } : {
                                            id: ids,
                                            section: "custom",
                                            tag: tag
                                        }
                                    });
                                }
                            } else {
                                router.push({
                                    pathname: "/login"
                                });
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "hidden md:block",
                                children: t("viewAll")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrow/* IconArrow */.C, {
                                isCaret: true,
                                direction: "right",
                                color: "#883CFF"
                            })
                        ]
                    })
                ]
            }) : null,
            !getCourses.isLoading && currData && currData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: isDesktopView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    ...settings,
                    navigation: isDesktopView && currData.length > 4,
                    onSlideNextTransitionStart: (_)=>{
                        buttonHandler("Next Courses");
                    },
                    onSlidePrevTransitionStart: (_)=>{
                        buttonHandler("Previous Courses");
                    },
                    children: title === "sectionNew" || title === "Kursus Terdownload" || isPopular ? currData.slice(0, 3).map((course, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonCircle */.s7, {}),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCourseWithLesson, {
                                    ...course,
                                    tracker: {
                                        event: "b2b_homepage_course_a",
                                        property: {
                                            course_name: course?.name,
                                            course_slug: course?.slug,
                                            institution_name: course?.institution?.name,
                                            category_name: tag ?? t(title) ?? "",
                                            section,
                                            index,
                                            is_mandatory_course: false
                                        }
                                    }
                                })
                            })
                        }, "Swiper-" + course.slug)) : showedItems?.slice(0, 3).map((course, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonCircle */.s7, {}),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCourseWithLesson, {
                                    ...course,
                                    tracker: {
                                        event: "b2b_homepage_course_a",
                                        property: {
                                            course_name: course?.name,
                                            course_slug: course?.slug,
                                            institution_name: course?.institution?.name,
                                            category_name: tag ?? t(title) ?? "",
                                            section,
                                            index,
                                            is_mandatory_course: false
                                        }
                                    }
                                })
                            })
                        }, "Swiper-" + course.slug))
                }) : // mobile view
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-2 gap-[8px]",
                    children: title === "sectionNew" || isPopular ? currData.slice(0, 4).map((course, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonCircle */.s7, {}),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardCourseSectionMobile, {
                                ...course,
                                tracker: {
                                    event: "b2b_homepage_course_a",
                                    property: {
                                        course_name: course?.name,
                                        course_slug: course?.slug,
                                        institution_name: course?.institution?.name,
                                        category_name: tag ?? t(title) ?? "",
                                        section,
                                        index,
                                        is_mandatory_course: false
                                    }
                                },
                                wrapClass: "w-[300px] md:w-full"
                            })
                        })) : currData.slice(0, 4).map((course, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonCircle */.s7, {}),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardCourseSectionMobile, {
                                ...course,
                                tracker: {
                                    event: "b2b_homepage_course_a",
                                    property: {
                                        course_name: course?.name,
                                        course_slug: course?.slug,
                                        institution_name: course?.institution?.name,
                                        category_name: tag ?? t(title) ?? "",
                                        section,
                                        index,
                                        is_mandatory_course: false
                                    }
                                },
                                wrapClass: "w-[300px] md:w-full"
                            })
                        }))
                })
            }),
            getCourses.isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonWrapper */.nR, {
                className: "grid grid-cols-3 xl-max:grid-cols-2 hg-max:!grid-cols-1 gap-20 my-30",
                children: [
                    1,
                    2,
                    3
                ].map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                        className: "h-300 rounded-8 w-full"
                    }, el))
            })
        ]
    });
};
/* harmony default export */ var Tenant_Section = (Section);

// EXTERNAL MODULE: ./src/modules/MyClass/myClassApi.ts
var myClassApi = __webpack_require__(12337);
;// CONCATENATED MODULE: ./src/lib/sections.ts
const SECTION_GERBANGSARI = [
    "Selamat datang di Gerbangsari goKampus",
    "Pertanian",
    "Personal Development",
    "Customer Excellence",
    "Product Design & Management",
    "Pengusaha",
    "Penjualan"
];
const SECTION_MALUKU = [
    // it can be adjust on zeus
    // "UMKM",
    // "Marketing & Branding",
    "Personal Development"
];
const SECTION_PLUS = [
    {
        id: "1",
        title: `sectionTech`,
        tag: "Digital & IT",
        sort: null,
        emoji: "\uD83D\uDCBB"
    },
    {
        id: "99",
        title: `sectionNew`,
        tag: "newest",
        sort: "created_date",
        emoji: `🆕`
    },
    {
        id: "3",
        title: `sectionManagement`,
        tag: "Personal Development",
        sort: null,
        emoji: "⏰"
    }
];
const SECTION_BASIC = [
    {
        id: "1",
        title: `sectionWork`,
        tag: "Performance & Productivity",
        sort: null,
        emoji: "\uD83E\uDDD1‍\uD83D\uDCBC"
    },
    {
        id: "2",
        title: `sectionTech`,
        tag: "Digital & IT",
        sort: null,
        emoji: "\uD83D\uDCBB"
    },
    {
        id: "3",
        title: `sectionManagement`,
        tag: "Personal Development",
        sort: null,
        emoji: "⏰"
    }
];
const SECTION_PRO = [
    {
        id: "1",
        title: `sectionWork`,
        tag: "Performance & Productivity",
        sort: null,
        emoji: "\uD83E\uDDD1‍\uD83D\uDCBC"
    },
    {
        id: "2",
        title: `sectionManagement`,
        tag: "Personal Development",
        sort: null,
        emoji: "⏰"
    },
    {
        id: "3",
        title: `sectionTech`,
        tag: "Digital & IT",
        sort: null,
        emoji: "\uD83D\uDCBB"
    }
];
const SECTION_MANDATORY = [
    {
        id: "1",
        title: `mandatoryCourses`,
        tag: null,
        sort: null,
        emoji: null
    }
];
const mapArrayToSection = (inputArray)=>{
    return inputArray.map((item, index)=>{
        return {
            id: `${SECTION_PRO.length + index + 1}`,
            title: `section${item.replace(/\s/g, "")}`,
            tag: item,
            sort: null,
            emoji: null // You can set a default emoji or choose based on your requirements
        };
    });
};
const mapTagsToSection = (listTags)=>{
    return listTags.map((el, idx)=>{
        return {
            id: idx,
            title: null,
            tag: el,
            sort: null,
            emoji: null
        };
    });
};

;// CONCATENATED MODULE: ./src/lib/useInfiniteScroll.ts

const useInfiniteScroll = (loadMore, hasMore, isLoader)=>{
    const observer = (0,react.useRef)(null);
    const lastCourseElm = (0,react.useCallback)((node)=>{
        if (isLoader || !hasMore) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting) {
                loadMore();
            }
        });
        if (node) observer.current.observe(node);
    }, [
        isLoader,
        hasMore,
        loadMore
    ]);
    return lastCourseElm;
};
/* harmony default export */ var lib_useInfiniteScroll = (useInfiniteScroll);

// EXTERNAL MODULE: ./src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(61097);
// EXTERNAL MODULE: ./src/components/Icon/IconClose.tsx
var IconClose = __webpack_require__(84132);
// EXTERNAL MODULE: ./src/lib/ssr.ts
var ssr = __webpack_require__(11927);
// EXTERNAL MODULE: ./src/components/PageHeader/systemStore.ts
var systemStore = __webpack_require__(96937);
;// CONCATENATED MODULE: ./src/components/Icon/IconCheckboxActive.tsx



const IconCheckboxActive = ({ size =20 , color ="#318A4E"  })=>{
    const theme = (0,systemStore/* useSystemStore */.m)((state)=>state.theme);
    if (theme == "dark") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: size,
            height: size,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "2",
                    y: "2",
                    width: "20",
                    height: "20",
                    rx: "7",
                    fill: "#D9D9D9"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M7 2H17C18.3261 2 19.5979 2.52678 20.5355 3.46447C21.4732 4.40215 22 5.67392 22 7V17C22 18.3261 21.4732 19.5979 20.5355 20.5355C19.5979 21.4732 18.3261 22 17 22H7C5.67392 22 4.40215 21.4732 3.46447 20.5355C2.52678 19.5979 2 18.3261 2 17V7C2 5.67392 2.52678 4.40215 3.46447 3.46447C4.40215 2.52678 5.67392 2 7 2ZM18.1718 9.66763C18.6094 9.21751 18.6094 8.48772 18.1718 8.03759C17.7341 7.58747 17.0245 7.58747 16.5869 8.03759L10.5395 14.2572C10.3573 14.4446 10.0565 14.4446 9.87427 14.2572L7.41314 11.726C6.97548 11.2758 6.2659 11.2758 5.82824 11.726C5.39059 12.1761 5.39059 12.9059 5.82824 13.356L8.78049 16.3923C9.56827 17.2026 10.8455 17.2026 11.6333 16.3923L18.1718 9.66763Z",
                    fill: "#A184DD"
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: size,
            height: size,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "2",
                    y: "2",
                    width: "20",
                    height: "20",
                    rx: "7",
                    fill: "#D9D9D9"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M7 2H17C18.3261 2 19.5979 2.52678 20.5355 3.46447C21.4732 4.40215 22 5.67392 22 7V17C22 18.3261 21.4732 19.5979 20.5355 20.5355C19.5979 21.4732 18.3261 22 17 22H7C5.67392 22 4.40215 21.4732 3.46447 20.5355C2.52678 19.5979 2 18.3261 2 17V7C2 5.67392 2.52678 4.40215 3.46447 3.46447C4.40215 2.52678 5.67392 2 7 2ZM18.1718 9.66763C18.6094 9.21751 18.6094 8.48772 18.1718 8.03759C17.7341 7.58747 17.0245 7.58747 16.5869 8.03759L10.5395 14.2572C10.3573 14.4446 10.0565 14.4446 9.87427 14.2572L7.41314 11.726C6.97548 11.2758 6.2659 11.2758 5.82824 11.726C5.39059 12.1761 5.39059 12.9059 5.82824 13.356L8.78049 16.3923C9.56827 17.2026 10.8455 17.2026 11.6333 16.3923L18.1718 9.66763Z",
                    fill: "#551FC1"
                })
            ]
        });
    }
};

;// CONCATENATED MODULE: ./src/components/Icon/IconCheckboxNonActive.tsx



const IconCheckboxNonActive = ({ size =20 , color ="#318A4E"  })=>{
    const theme = (0,systemStore/* useSystemStore */.m)((state)=>state.theme);
    if (theme == "dark") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: size,
            height: size,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 2H7C5.67392 2 4.40215 2.52678 3.46447 3.46447C2.52678 4.40215 2 5.67392 2 7V17C2 18.3261 2.52678 19.5979 3.46447 20.5355C4.40215 21.4732 5.67392 22 7 22H17C18.3261 22 19.5979 21.4732 20.5355 20.5355C21.4732 19.5979 22 18.3261 22 17V7C22 5.67392 21.4732 4.40215 20.5355 3.46447C19.5979 2.52678 18.3261 2 17 2V2ZM20 17C20 17.7956 19.6839 18.5587 19.1213 19.1213C18.5587 19.6839 17.7956 20 17 20H7C6.20435 20 5.44129 19.6839 4.87868 19.1213C4.31607 18.5587 4 17.7956 4 17V7C4 6.20435 4.31607 5.44129 4.87868 4.87868C5.44129 4.31607 6.20435 4 7 4H17C17.7956 4 18.5587 4.31607 19.1213 4.87868C19.6839 5.44129 20 6.20435 20 7V17Z",
                fill: "#E5E5E5"
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: size,
            height: size,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 2H7C5.67392 2 4.40215 2.52678 3.46447 3.46447C2.52678 4.40215 2 5.67392 2 7V17C2 18.3261 2.52678 19.5979 3.46447 20.5355C4.40215 21.4732 5.67392 22 7 22H17C18.3261 22 19.5979 21.4732 20.5355 20.5355C21.4732 19.5979 22 18.3261 22 17V7C22 5.67392 21.4732 4.40215 20.5355 3.46447C19.5979 2.52678 18.3261 2 17 2V2ZM20 17C20 17.7956 19.6839 18.5587 19.1213 19.1213C18.5587 19.6839 17.7956 20 17 20H7C6.20435 20 5.44129 19.6839 4.87868 19.1213C4.31607 18.5587 4 17.7956 4 17V7C4 6.20435 4.31607 5.44129 4.87868 4.87868C5.44129 4.31607 6.20435 4 7 4H17C17.7956 4 18.5587 4.31607 19.1213 4.87868C19.6839 5.44129 20 6.20435 20 7V17Z",
                fill: "#3E3851"
            })
        });
    }
};

// EXTERNAL MODULE: ./src/modules/Home/homeStore.ts
var homeStore = __webpack_require__(88727);
;// CONCATENATED MODULE: ./src/modules/Tenant/FilterTenant.tsx



















const dataRating = [
    {
        id: 1,
        label: "3.0",
        selected: false,
        value: [
            3.0,
            5.0
        ]
    },
    {
        id: 2,
        label: "3.5",
        selected: false,
        value: [
            3.5,
            5.0
        ]
    },
    {
        id: 3,
        label: "4.0",
        selected: false,
        value: [
            4.0,
            5.0
        ]
    },
    {
        id: 4,
        label: "4.5",
        selected: false,
        value: [
            4.5,
            5.0
        ]
    }
];
const dataSort = [
    {
        id: 1,
        label: "highestRating",
        selected: false,
        value: "rating_avg",
        name: "Rating Tertinggi"
    },
    {
        id: 2,
        label: "popular",
        selected: false,
        value: "total_learners",
        name: "Terpopuler"
    },
    {
        id: 3,
        label: "newest",
        selected: false,
        value: "created_date",
        name: "Terbaru"
    }
];
const FilterTenant = /*#__PURE__*/ (0,react.forwardRef)(({ onFilter , onReset , isLoadingOn =false , setFilters , filters , currentSort , sortDesc , onSetCurrentSort , setSortByDesc , keyword , closeModal , dataCompetences , ...props }, ref)=>{
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const { t: tr  } = (0,useTranslation/* default */.Z)("tags");
    const dataPerView = 6;
    const router = (0,next_router.useRouter)();
    const [sortings, setSelectedSort] = (0,react.useState)(dataSort);
    const [ratings, setSelectedRatings] = (0,react.useState)(dataRating.sort(function(a, b) {
        return b.id - a.id;
    }));
    const [isLoading, setIsLoading] = (0,react.useState)({
        reset: false,
        apply: false
    });
    const isDesktop = (0,device/* useIsDesktop */.Ce)();
    const [allIns, setInstitutions] = (0,react.useState)([]);
    const [competences, setCompetences] = (0,react.useState)([]);
    const sortKey = router.query.sortBy ?? "";
    const institutionKey = router.query.institutionKey ?? "";
    const tagsKey = router.query.tagsKey ?? "";
    const q = router.query.q ?? "";
    const isAvailableReset = institutionKey || tagsKey || sortKey;
    const subDomain = (0,ssr/* isBrowser */.j)() ? (0,host/* getSubDomain */.ZC)(window.location.hostname) : null;
    const isSubdomainTenant = (0,host/* useIsSubdomain */.Do)();
    const screen =  true && window.innerWidth;
    const isMobile = screen < 770;
    const isBlueBirdTenant =  true && ((0,host/* isBlueBirdURL */.TJ)(window.location.hostname) || (0,host/* isSubdomainBluebird */.ok)(window.location.hostname));
    const classFilterBtn = "border rounded-full px-12 py-8 text-b2 font-light flex items-center gap-8 cursor-pointer ";
    const classTitleText = "text-neutral80_to_dark10 text-b1 font-medium";
    const classSubitleText = "text-neutral-70 text-c1 font-light";
    const { currentUser  } = (0,Auth_authStore/* useAuthStore */.t)((state)=>({
            loginState: state.loginState,
            currentUser: state.currentUser
        }));
    const { renderingStep  } = (0,homeStore/* useHomeStore */.o)();
    //@ts-ignore
    const exploreCourseInstitutions = (0,exploreApi/* useInstitutionsTenant */.KR)();
    (0,react.useEffect)(()=>{
        if (dataCompetences) {
            setCompetences(dataCompetences.filter((a)=>a.tags.length > 0));
        }
    }, [
        dataCompetences,
        renderingStep
    ]);
    const refferal = isSubdomainTenant ? currentUser?.referral ?? subDomain : currentUser?.referral;
    const referralCode = (0,helper/* getCookie */.ej)("ref_code_gk") && (0,helper/* getCookie */.ej)("ref_code_gk") !== "null" ? (0,helper/* getCookie */.ej)("ref_code_gk") : "";
    (0,react.useEffect)(()=>{
        // if (!currentUser) return;
        if (refferal) {
            exploreCourseInstitutions.doFetch({
                //@ts-ignore
                slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : // ? referralCode
                refferal
            }, {
                onSuccess (res) {
                    const allInstitutions = res.data.length ? res.data.map((a)=>{
                        return {
                            name: `${a.name}`,
                            image: a.image_url,
                            selected: institutionKey === a.slug,
                            slug: a.slug
                        };
                    }) : [];
                    setInstitutions(allInstitutions);
                }
            });
        }
    }, [
        refferal,
        referralCode
    ]);
    (0,react.useEffect)(()=>{
        if (sortKey) {
            setSelectedSort(sortings.map((el)=>el.value === sortKey ? {
                    ...el,
                    selected: true
                } : {
                    ...el,
                    selected: false
                }));
        }
    }, []);
    (0,react.useEffect)(()=>{
        setSelectedSort((prevSortings)=>prevSortings.map((el)=>({
                    ...el,
                    selected: el.value === sortKey
                })));
    }, [
        sortKey
    ]);
    (0,react.useEffect)(()=>{
        let institutionFilter = [];
        if (allIns.length) {
            allIns.forEach((a)=>{
                if (a.selected) {
                    // institutionFilter.push(a.slug);
                    institutionFilter.push(`${a.name}||${a.image}`);
                }
            });
        }
        if (institutionFilter.length > 0) {
            router.push({
                pathname: "/",
                query: {
                    ...router.query,
                    institutionKey: institutionFilter.length > 0 ? institutionFilter.join(",") : undefined
                }
            });
        }
    }, [
        allIns
    ]);
    (0,react.useEffect)(()=>{
        let tagsFilter = [];
        if (competences.length) {
            competences.forEach((a)=>{
                a.tags.forEach((x)=>{
                    if (x.selected) {
                        tagsFilter.push(x.name);
                    }
                });
            });
        }
        if (tagsFilter.length > 0) {
            router.push({
                pathname: "/",
                query: {
                    ...router.query,
                    tagsKey: tagsFilter.length > 0 ? tagsFilter.join(",") : undefined
                }
            });
        }
    }, [
        competences
    ]);
    (0,react.useEffect)(()=>{
        if (sortings.some((a)=>a.selected)) {
            router.push({
                pathname: "/",
                query: {
                    ...router.query,
                    sortBy: sortings.find((x)=>x.selected)?.value
                }
            });
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (!router.query.tagsKey) {
            resetCompetencies();
        }
    }, [
        tagsKey
    ]);
    (0,react.useEffect)(()=>{
        if (!router.query.institutionKey) {
            resetInstitutions();
        }
    }, [
        institutionKey
    ]);
    const [next, setNext] = (0,react.useState)(dataPerView);
    const [nextIns, setNextIns] = (0,react.useState)(dataPerView);
    const handleMore = ()=>{
        (0,amplitude/* trackEvent */.L9)({
            event: "srp_filter_more_a",
            property: {
                page: `B2B Homepage`,
                filter_type: "Kategori"
            }
        });
        (0,amplitude/* trackEventGTM */.hk)({
            event: "srp_filter_more_a",
            property: {
                page: `B2B Homepage`,
                filter_type: "Kategori"
            }
        });
        (0,amplitude/* trackEventGA */.w7)({
            event: "srp_filter_more_a",
            property: {
                page: `B2B Homepage`,
                filter_type: "Kategori"
            }
        });
        setNext(next + dataPerView);
    };
    const handleMoreIns = (totalShowInstitution)=>{
        (0,amplitude/* trackEvent */.L9)({
            event: "srp_filter_more_a",
            property: {
                page: `B2B Homepage`,
                filter_type: "Institusi"
            }
        });
        (0,amplitude/* trackEventGTM */.hk)({
            event: "srp_filter_more_a",
            property: {
                page: `B2B Homepage`,
                filter_type: "Institusi"
            }
        });
        (0,amplitude/* trackEventGA */.w7)({
            event: "srp_filter_more_a",
            property: {
                page: `B2B Homepage`,
                filter_type: "Institusi"
            }
        });
        setNextIns(totalShowInstitution);
    };
    const resetCompetencies = ()=>{
        setCompetences(competences.map((comp)=>({
                ...comp,
                selected: false,
                tags: comp.tags.map((tag)=>({
                        ...tag,
                        selected: false
                    }))
            })));
    };
    const resetInstitutions = ()=>{
        setInstitutions(allIns.map((a)=>{
            return {
                ...a,
                selected: false
            };
        }));
    // setInstitutions(newAllIns);
    };
    const resetFilter = ()=>{
        // remove all query param url
        router.push({
            pathname: "/"
        }, undefined, {
            shallow: true
        });
        setIsLoading({
            ...isLoading,
            reset: true
        });
        resetInstitutions();
        setSelectedRatings(ratings.map((a)=>{
            return {
                ...a,
                selected: false
            };
        }));
        setSelectedSort([
            ...sortings
        ].map((el)=>{
            return {
                ...el,
                selected: false
            };
        }));
        resetCompetencies();
        (0,amplitude/* trackEvent */.L9)({
            event: "srp_filter_reset_a",
            property: {
                page: `B2B Homepage`
            }
        });
        (0,amplitude/* trackEventGTM */.hk)({
            event: "srp_filter_reset_a",
            property: {
                page: `B2B Homepage`
            }
        });
        (0,amplitude/* trackEventGA */.w7)({
            event: "srp_filter_reset_a",
            property: {
                page: `B2B Homepage`
            }
        });
        setIsLoading({
            ...isLoading,
            reset: false
        });
        onReset();
    };
    // useImperativeHandle(ref, () => ({
    //   resetFilter,
    // }));
    const handleTagClick = (competenceIndex, tagIndex, info)=>{
        const { parent ="" , tag =""  } = info;
        (0,amplitude/* trackEvent */.L9)({
            event: "srp_filter_a",
            property: {
                page: `B2B Homepage`,
                filter_type: parent,
                filter_value: tag
            }
        });
        (0,amplitude/* trackEventGTM */.hk)({
            event: "srp_filter_a",
            property: {
                page: `B2B Homepage`,
                filter_type: parent,
                filter_value: tag
            }
        });
        (0,amplitude/* trackEventGA */.w7)({
            event: "srp_filter_a",
            property: {
                page: `B2B Homepage`,
                filter_type: parent,
                filter_value: tag
            }
        });
        const updatedCompetences = [
            ...competences
        ];
        updatedCompetences[competenceIndex].tags[tagIndex].selected = !updatedCompetences[competenceIndex].tags[tagIndex].selected;
        setCompetences(updatedCompetences);
    };
    const handleCompetenceClick = (competenceIndex, name)=>{
        (0,amplitude/* trackEvent */.L9)({
            event: "srp_filter_a",
            property: {
                pageHo: `B2B Homepage`,
                filter_type: name,
                filter_value: name
            }
        });
        (0,amplitude/* trackEventGTM */.hk)({
            event: "srp_filter_a",
            property: {
                pageHo: `B2B Homepage`,
                filter_type: name,
                filter_value: name
            }
        });
        (0,amplitude/* trackEventGA */.w7)({
            event: "srp_filter_a",
            property: {
                pageHo: `B2B Homepage`,
                filter_type: name,
                filter_value: name
            }
        });
        const updatedCompetences = [
            ...competences
        ];
        updatedCompetences[competenceIndex].selected = !updatedCompetences[competenceIndex].selected;
        updatedCompetences[competenceIndex].tags.forEach((tag)=>{
            tag.selected = updatedCompetences[competenceIndex].selected;
        });
        setCompetences(updatedCompetences);
    };
    const renderInstitution = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid gap-12 pb-0 px-0 mt-12",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    className: `${classTitleText} md:px-0 px-16`,
                    children: t("institution")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-2 md:grid-cols-1 gap-12 md:px-0 px-16",
                    children: allIns?.slice(0, nextIns)?.map((a, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-8 items-center justify-start cursor-pointer",
                            onClick: ()=>{
                                const currKey = institutionKey ? institutionKey.split(",") : [];
                                if (true) {
                                    window.scrollTo({
                                        top: 200,
                                        behavior: "smooth"
                                    });
                                }
                                if (a.selected && currKey.includes(`${a.name}||${a.image}`)) {
                                    // if (a.selected && currKey.includes(a.slug)) {
                                    // const newKey = currKey.filter((y) => y !== a.slug);
                                    const newKey = currKey.filter((y)=>y !== `${a.name}||${a.image}`);
                                    const newQuery = {
                                        ...router.query
                                    };
                                    if (newKey.length === 0) {
                                        delete newQuery.institutionKey;
                                    } else {
                                        newQuery.institutionKey = newKey.join(",");
                                    }
                                    router.push({
                                        pathname: "/",
                                        query: newQuery
                                    });
                                }
                                (0,amplitude/* trackEvent */.L9)({
                                    event: "srp_filter_a",
                                    property: {
                                        page: `B2B Homepage`,
                                        filter_type: "Institusi",
                                        filter_value: a.slug
                                    }
                                });
                                (0,amplitude/* trackEventGTM */.hk)({
                                    event: "srp_filter_a",
                                    property: {
                                        page: `B2B Homepage`,
                                        filter_type: "Institusi",
                                        filter_value: a.name
                                    }
                                });
                                (0,amplitude/* trackEventGA */.w7)({
                                    event: "srp_filter_a",
                                    property: {
                                        page: `B2B Homepage`,
                                        filter_type: "Institusi",
                                        filter_value: a.name
                                    }
                                });
                                setInstitutions(allIns.map((x)=>x.slug == a.slug ? {
                                        ...x,
                                        selected: !x.selected
                                    } : {
                                        ...x
                                    }));
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-24 h-24 min-w-24 max-w-24 min-h-24 max-h-24",
                                    children: a.selected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheckboxActive, {
                                        size: 24
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheckboxNonActive, {
                                        size: 24
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-32 h-32 rounded-full flex justify-center items-center " + (theme == "dark" ? "bg-white_to_white" : ""),
                                    children: a.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: 32,
                                        height: 32,
                                        src: a.image,
                                        alt: a.name,
                                        className: "w-32 h-32 object-cover object-center"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-32 h-32 bg-neutral-20 rounded-full"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-neutral-80 max-w-60 md:max-w-130 text-b2 font-light line-clamp-1",
                                    children: a.name
                                })
                            ]
                        }, a.key ?? a.slug ?? "" + i))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "secondary_transparant",
                    className: "border-none !text-violet_main_to_dark_purple_surface",
                    isFull: true,
                    onClick: ()=>handleMoreIns(nextIns < allIns?.length ? allIns?.length : dataPerView),
                    children: nextIns < allIns?.length ? t("seeMore") : t("seeLess")
                })
            ]
        });
    const theme = (0,systemStore/* useSystemStore */.m)((state)=>state.theme);
    const [displayedTagsCounts, setDisplayedTagsCounts] = (0,react.useState)([
        1,
        2
    ].map(()=>3));
    const handleSeeMoreClick = (competenceIndex, title, totalShowCompetences)=>{
        (0,amplitude/* trackEvent */.L9)({
            event: "srp_filter_more_a",
            property: {
                page: `B2B Homepage`,
                filter_type: title
            }
        });
        (0,amplitude/* trackEventGTM */.hk)({
            event: "srp_filter_more_a",
            property: {
                page: `B2B Homepage`,
                filter_type: title
            }
        });
        (0,amplitude/* trackEventGA */.w7)({
            event: "srp_filter_more_a",
            property: {
                page: `B2B Homepage`,
                filter_type: title
            }
        });
        setDisplayedTagsCounts((prevCounts)=>{
            const newCounts = [
                ...prevCounts
            ];
            newCounts[competenceIndex] = totalShowCompetences;
            return newCounts;
        });
    };
    const renderCompetences = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: competences?.map((c, competenceIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-14 md:px-0 px-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-12 items-center font-light cursor-pointer my-8",
                            onClick: ()=>handleCompetenceClick(competenceIndex, c.name),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-24 h-24 flex-shrink-0",
                                    children: c.selected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheckboxActive, {
                                        size: 24
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheckboxNonActive, {
                                        size: 24
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-b1 text-neutral80_to_dark10 font-medium mb-2",
                                    children: tr(c.name)
                                })
                            ]
                        }, c + Math.random()),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid grid-cols-2 md:grid-cols-1 gap-12",
                            children: c.tags// .slice(0, displayMoreTags[competenceIndex] ? c.tags.length : 3)
                            .slice(0, displayedTagsCounts[competenceIndex]).map((t, tagIndex)=>{
                                const info = {
                                    parent: c.name,
                                    tag: t.name
                                };
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-12 items-center font-light cursor-pointer",
                                    onClick: ()=>{
                                        handleTagClick(competenceIndex, tagIndex, info);
                                        const currTags = tagsKey ? tagsKey.split(",") : [];
                                        if (!t.selected && currTags.includes(t.name)) {
                                            const newKey = currTags.filter((x)=>x !== t.name);
                                            const newQuery = {
                                                ...router.query
                                            };
                                            if (newKey.length === 0) {
                                                delete newQuery.tagsKey;
                                            } else {
                                                newQuery.tagsKey = newKey.join(",");
                                            }
                                            router.push({
                                                pathname: "/",
                                                query: newQuery
                                            });
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex-shrink-0",
                                            children: t.selected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheckboxActive, {
                                                size: 24
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheckboxNonActive, {
                                                size: 24
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-neutral80_to_dark10 max-w-100 md:max-w-200 text-b2 font-light line-clamp-2",
                                            children: tr(t.name)
                                        })
                                    ]
                                }, t + Math.random());
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "secondary_transparant",
                            className: "border-none !text-violet_main_to_dark_purple_surface !my-8",
                            isFull: true,
                            //
                            onClick: ()=>handleSeeMoreClick(competenceIndex, c.name, c.tags.length > displayedTagsCounts[competenceIndex] ? c.tags.length : 3),
                            children: c.tags.length > displayedTagsCounts[competenceIndex] ? t("seeMore") : t("seeLess")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "border-b border-b-neutral-10 w-[95%] mx-auto"
                        })
                    ]
                }))
        });
    const onApply = ()=>{
        closeModal();
        (0,amplitude/* trackEvent */.L9)({
            event: "srp_filter_submit_a",
            property: {
                page: `B2B Homepage`
            }
        });
        (0,amplitude/* trackEventGTM */.hk)({
            event: "srp_filter_submit_a",
            property: {
                page: `B2B Homepage`
            }
        });
        (0,amplitude/* trackEventGA */.w7)({
            event: "srp_filter_submit_a",
            property: {
                page: `B2B Homepage`
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${!isDesktop ? "min-h-[calc(100vh-68px)] h-[calc(100vh-68px)]" : "h-full"} overflow-auto hide-scrollbar`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md-max:fixed md-max:top-0 md-max:left-0 md-max:right-0 flex px-16 py-8 justify-between items-center md:px-0 md:!border-b-0 border-b border-b-neutral20_to_dark30 bg-white rounded-t-xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-b1 text-neutral-80 font-medium md:hidden block",
                        children: "Filter"
                    }),
                    isAvailableReset && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cursor-pointer text-violet_main_to_dark_purple_surface hidden md:block text-b1 font-medium",
                        onClick: ()=>resetFilter(),
                        children: "Reset filter"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: closeModal,
                        className: "md:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* default */.Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `hide-scrollbar flex flex-col pb-[74px] pt-42 ${isBlueBirdTenant ? "md:max-h-[70vh]" : isDesktop ? "max-h-[95vh] pt-[0px] pb-[0px]" : "max-h-[85vh]"} gap-12 overflow-scroll`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid gap-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: `grid gap-12 ${isAvailableReset ? "pt-8" : "pt-0"}`,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    className: `${classTitleText} md:px-0 px-16`,
                                    children: t("sort")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex md:px-0 px-16 flex-wrap " + classSubitleText,
                                    children: sortings.map((a)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: `${classFilterBtn + (a.selected ? // : "border-neutral-40 text-neutral-70"
                                            "bg-violet_main_to_dark_purple_surface text-white_to_white border-violet_main" : "border-light_neutral10_to_dark_neutral50 text-neutral80_to_dark10 bg-light_neutral10_to_dark_neutral50")} flex justify-center mb-12 mr-12`,
                                            onClick: ()=>{
                                                const currentSortBy = router.query.sortBy;
                                                const newQuery = {
                                                    ...router.query
                                                };
                                                if (currentSortBy === a.value) {
                                                    delete newQuery.sortBy;
                                                } else {
                                                    newQuery.sortBy = a.value;
                                                }
                                                router.push({
                                                    pathname: "/",
                                                    query: newQuery
                                                });
                                                (0,amplitude/* trackEventGTM */.hk)({
                                                    event: "srp_filter_a",
                                                    property: {
                                                        page: `B2B Homepage`,
                                                        filter_type: "Urutkan",
                                                        filter_value: a.name
                                                    }
                                                });
                                                (0,amplitude/* trackEventGA */.w7)({
                                                    event: "srp_filter_a",
                                                    property: {
                                                        page: `B2B Homepage`,
                                                        filter_type: "Urutkan",
                                                        filter_value: a.name
                                                    }
                                                });
                                                setSelectedSort(sortings.map((x)=>a == x ? {
                                                        ...x,
                                                        selected: true
                                                    } : {
                                                        ...x,
                                                        selected: false
                                                    }));
                                                setSortByDesc(a.value);
                                                onSetCurrentSort({
                                                    ...currentSort,
                                                    [a.value]: true
                                                });
                                            },
                                            children: t(a.label)
                                        }, Math.random() + "IconFilter");
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "border-b border-b-neutral-10 w-[95%] mx-auto"
                                }),
                                renderCompetences(),
                                currentUser?.referral !== "kemenperin" ? renderInstitution() : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            ]
                        })
                    ]
                })
            }),
            isBlueBirdTenant && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `sticky py-12`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-b2 font-light",
                        children: "Powered by"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: theme == "dark" ? "/logo-white-2048.png" : "/logo-2048.png",
                        alt: "learnext",
                        width: 120,
                        height: 21
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed bottom-0 left-0 right-0 bg-white py-18 md:hidden border-t border-neutral20_to_dark30",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-16 grid grid-cols-2 gap-x-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "secondary",
                            isFull: true,
                            rounded: "full",
                            state: isAvailableReset ? "active" : "disabled",
                            onClick: ()=>resetFilter(),
                            children: "RESET"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            isFull: true,
                            rounded: "full",
                            state: isAvailableReset ? "active" : "disabled",
                            onClick: onApply,
                            children: "TERAPKAN"
                        })
                    ]
                })
            })
        ]
    });
});

// EXTERNAL MODULE: ./src/lib/algolia.ts
var algolia = __webpack_require__(96131);
// EXTERNAL MODULE: ./src/lib/object.ts
var object = __webpack_require__(12582);
// EXTERNAL MODULE: ./node_modules/react-spinners/esm/MoonLoader.js
var MoonLoader = __webpack_require__(13173);
;// CONCATENATED MODULE: ./src/modules/Tenant/HomeCard.tsx



















const HomeCard_CardCourseWithLesson = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 97216)).then((mod)=>mod.default), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(97216)
            ]
    },
    ssr: false
});
const HomeCard = ({ data , filters , sortDesc , searchText , textValue , sections , isSquare =false , isHidden , keywordOthers , isKeywordsSearched , handleReset  })=>{
    const isDesktop = (0,device/* useIsDesktop */.Ce)();
    const screen =  true && window.innerWidth;
    const isMobile = screen < 770;
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const { t: tCourse  } = (0,useTranslation/* default */.Z)("course");
    const [page, setPage] = (0,react.useState)(1);
    const [totalPage, setTotalPage] = (0,react.useState)(1);
    const [nbHits, setNbHits] = (0,react.useState)(null);
    const [totalData, setTotalData] = (0,react.useState)(0);
    const [indexName, setIndexName] = (0,react.useState)("");
    const domain =  true && window.location.hostname;
    const { currentRecommend , totalFilter , setTotalFilter  } = (0,searchStore/* useSearchStore */.R)((state)=>({
            currentRecommend: state.currentRecommend,
            totalFilter: state.totalFilter,
            setTotalFilter: state.setTotalFilter
        }));
    const setRecommendData = (0,searchStore/* useSearchStore */.R)((state)=>state.setRecommendData);
    const router = (0,next_router.useRouter)();
    const q = router?.query?.q ?? "";
    const isB2B = (0,host/* useIsTenant */.we)() || (0,host/* useIsSubdomain */.Do)();
    const accessCourseApi = (0,exploreApi/* useAccessCourseTenant */.le)();
    const institutionNames = typeof router.query.institutionKey == "string" && router.query.institutionKey ? router.query.institutionKey.split(",") : [];
    const institutionKeyFilter = institutionNames.length ? `${institutionNames.map((ins)=>`institution:"${ins}"`).join(" OR ")}` : "";
    const tagsNames = typeof router.query.tagsKey == "string" && router.query.tagsKey ? router.query.tagsKey.split(",") : [];
    const tagsKeyFilter = tagsNames.length ? `${tagsNames.map((ins)=>`tags:"${ins}"`).join(" OR ")}` : "";
    const sortByFilter = typeof router.query.sortBy == "string" ? router.query.sortBy : "";
    const referralCode = (0,helper/* getCookie */.ej)("ref_code_gk") && (0,helper/* getCookie */.ej)("ref_code_gk") !== "null" ? (0,helper/* getCookie */.ej)("ref_code_gk") :  true ? new URLSearchParams(window.location.search).get("referral") : 0;
    const getCoursesByTenant = (0,homeTenantApi/* useGetCoursesByTenantSlug */.HL)();
    const [tempData, setTempData] = (0,react.useState)(null);
    const subDomain = (0,ssr/* isBrowser */.j)() ? (0,host/* getSubDomain */.ZC)(window.location.hostname) : null;
    const PER_PAGE = 9;
    const [hasMore, setHasMore] = (0,react.useState)(true);
    const { loginState , currentUser  } = (0,Auth_authStore/* useAuthStore */.t)((state)=>({
            loginState: state.loginState,
            currentUser: state.currentUser
        }));
    const [emptyResults, setEmpty] = (0,react.useState)(false);
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    // State for course data - initialized as null
    const [mergedData, setMergedData] = (0,react.useState)(null);
    const observerRef = (0,react.useRef)(null);
    const [isInitialLoad, setIsInitialLoad] = (0,react.useState)(true);
    // Intersection Observer implementation
    (0,react.useEffect)(()=>{
        const observer = new IntersectionObserver((entries)=>{
            const [entry] = entries;
            if (entry.isIntersecting && hasMore && !isLoading && mergedData !== null) {
                setPage((prev)=>prev + 1);
            }
        }, {
            root: null,
            rootMargin: "100px",
            threshold: 0.8
        });
        const currentRef = observerRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return ()=>{
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [
        hasMore,
        isLoading,
        mergedData
    ]);
    // Reset when filters change
    (0,react.useEffect)(()=>{
        setMergedData([]);
        setPage(1);
        setHasMore(true);
        setIsInitialLoad(true);
    }, [
        q,
        institutionKeyFilter,
        tagsKeyFilter,
        sortByFilter,
        isKeywordsSearched
    ]);
    // Main data fetching function
    const getListCourses = (idxName)=>{
        const allFilter = [
            institutionKeyFilter,
            tagsKeyFilter
        ].filter((a)=>a).join(" AND ");
        const params = {
            q,
            facetFilters: allFilter,
            page: page - 1,
            hitsPerPage: PER_PAGE
        };
        if (isAnyFiltered || isKeywordsSearched) {
            setIsLoading(true);
            fetch(`/api/search-algolia?indexName=${idxName}&${new URLSearchParams((0,object/* parseDataParams */.bz)(params)).toString()}`).then((res)=>res.json()).then((res)=>{
                if (res?.data?.hits?.length) {
                    const algoliaHits = res.data.hits;
                    const nbHits = res.data.nbHits;
                    const totalPages = Math.ceil(nbHits / PER_PAGE);
                    setHasMore(page < totalPages);
                    setTotalData(nbHits);
                    // Process initial data (sorting, shuffling)
                    let processed = sortByFilter ? (0,object/* ArrayObjectSortBy */.Jy)(algoliaHits, sortByFilter, true) : q ? algoliaHits : (0,object/* ShuffleArray */.LQ)(algoliaHits);
                    // Filter for anonymous users
                    if (loginState !== "LOGIN") {
                        processed = processed.filter((a)=>!a.tenant);
                        updateMergedData(processed);
                        return;
                    }
                    // For logged-in users without referral
                    if (!currentUser?.referral) {
                        updateMergedData(processed);
                        return;
                    }
                    // Check course access for logged-in users with referral
                    accessCourseApi.doFetch({
                        // @ts-ignore
                        slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : currentUser?.referral
                    }, {
                        onSuccess: (accessData)=>{
                            const listAccessCourses = accessData?.data;
                            if (!Array.isArray(listAccessCourses) || listAccessCourses.length === 0) {
                                updateMergedData(processed);
                                return;
                            }
                            const userId = currentUser?.id;
                            const forbiddenCourses = new Set();
                            listAccessCourses.forEach((course)=>{
                                if (course.user !== userId) {
                                    if (Array.isArray(course.courses)) {
                                        course.courses.forEach((c)=>forbiddenCourses.add(c.slug));
                                    } else if (course.courses?.slug) {
                                        forbiddenCourses.add(course.courses.slug);
                                    }
                                }
                            });
                            // Filter out forbidden courses
                            if (forbiddenCourses.size > 0) {
                                processed = processed.filter((course)=>!forbiddenCourses.has(course.slug));
                            }
                            updateMergedData(processed);
                        },
                        onError: (err)=>{
                            ;
                            updateMergedData(processed);
                        }
                    });
                } else {
                    setHasMore(false);
                    setEmpty(true);
                    setIsLoading(false);
                }
            }).catch((err)=>{
                ;
                setEmpty(true);
                setIsLoading(false);
            });
        }
    };
    // Helper function to update merged data
    const updateMergedData = (newData)=>{
        setMergedData((prev)=>{
            if (isInitialLoad) {
                setIsInitialLoad(false);
                return newData;
            }
            // Filter out duplicates
            const uniqueNewData = newData.filter((newItem)=>!prev.some((existingItem)=>existingItem.id === newItem.id));
            return [
                ...prev,
                ...uniqueNewData
            ];
        });
        setNbHits(newData.length);
        setEmpty(newData.length === 0);
        setIsLoading(false);
    };
    (0,react.useEffect)(()=>{
        const computeIndexName = ()=>{
            if (!isKeywordsSearched && currentUser) {
                if (currentUser.referral.includes("gaji-c")) {
                    return currentUser.referral !== "gaji-c0000117" ? (0,algolia/* generateIndexName */.AP)("gaji") : (0,algolia/* generateIndexName */.AP)(currentUser.referral);
                }
                return (0,algolia/* generateIndexName */.AP)(window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : currentUser.referral === "bssn" ? "tapinkab" : currentUser.referral);
            }
            return (0,algolia/* generateIndexName */.AP)(window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : subDomain === "bssn" ? "tapinkab" : subDomain);
        };
        const indexName = computeIndexName();
        if (![
            "moodle",
            "example"
        ].includes(indexName)) {
            getListCourses(indexName);
        }
    }, [
        page,
        q,
        institutionKeyFilter,
        tagsKeyFilter,
        sortByFilter,
        isKeywordsSearched
    ]);
    (0,react.useEffect)(()=>{
        const filter = sortByFilter != "" ? 1 : 0;
        const totalNewFilter = tagsNames.length + institutionNames.length + filter;
        if (totalFilter != totalNewFilter) {
            setTotalFilter(totalNewFilter);
        }
    }, [
        tagsNames,
        institutionNames
    ]);
    const isAnyFiltered = tagsKeyFilter !== "" || institutionKeyFilter !== "" || sortByFilter !== "" || q !== "";
    const shouldShowCourseList = isAnyFiltered && mergedData !== null && mergedData.length > 0;
    const shouldShowEmptyState = isAnyFiltered && (mergedData === null || mergedData.length === 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !shouldShowEmptyState && (isAnyFiltered || isKeywordsSearched) && !isLoading && nbHits && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-24 flex justify-start items-center px-16 md:px-0 gap-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-light items-center flex",
                        dangerouslySetInnerHTML: {
                            __html: t(tagsKeyFilter !== "" || institutionKeyFilter !== "" ? "descriptionResultFilter" : "descriptionResultSearch", {
                                count: totalData,
                                text: `${tagsKeyFilter !== "" || institutionKeyFilter !== "" ? "" : q || isKeywordsSearched || (sortByFilter === "rating_avg" ? "Rating Tertinggi" : sortByFilter === "created_date" ? "Terbaru" : "Populer")}`,
                                additionalS: mergedData && mergedData.length > 1 ? "s" : ""
                            })
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: ()=>{
                            q ? router.push({
                                pathname: "/"
                            }) : handleReset();
                        },
                        className: "cursor-pointer block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* default */.Z, {
                            size: 20,
                            color: "#883CFF"
                        })
                    })
                ]
            }),
            isLoading && isAnyFiltered && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 mb-24 gap-40",
                children: [
                    [
                        ...Array(9)
                    ].map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Skeleton/* SkeletonWrapper */.nR, {
                            className: "flex items-start gap-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                    className: "h-[239px] flex-shrink-0 w-[426px] rounded-8"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Skeleton/* SkeletonWrapper */.nR, {
                                    className: "flex w-full flex-col gap-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                            className: "h-[24px] rounded-8"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                            className: "h-[36px] rounded-8"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                            className: "h-[24px] rounded-8"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                            className: "h-[56px] rounded-8"
                                        })
                                    ]
                                })
                            ]
                        })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-10 flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoonLoader/* default */.Z, {
                            size: isDesktop ? 45 : 20
                        })
                    })
                ]
            }),
            shouldShowCourseList && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 mb-24 gap-40",
                children: [
                    mergedData.map((course, index)=>{
                        const isLast = index === mergedData.length - 1;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: isLast ? observerRef : null,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCard_CardCourseWithLesson, {
                                ...course,
                                isRow: true,
                                isSquare: isSquare,
                                tracker: {
                                    event: "b2b_homepage_course_a",
                                    property: {
                                        course_name: course?.name,
                                        course_slug: course?.slug,
                                        institution_name: course?.institution?.name,
                                        section: 3,
                                        category_name: `Default`,
                                        index,
                                        is_mandatory_course: false
                                    }
                                }
                            })
                        }, course.name + index);
                    }),
                    isLoading && hasMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            [
                                ...Array(1)
                            ].map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Skeleton/* SkeletonWrapper */.nR, {
                                    className: "flex items-start gap-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                            className: "h-[239px] flex-shrink-0 w-[426px] rounded-8"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Skeleton/* SkeletonWrapper */.nR, {
                                            className: "flex w-full flex-col gap-8",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                                    className: "h-[24px] rounded-8"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                                    className: "h-[36px] rounded-8"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                                    className: "h-[24px] rounded-8"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                                    className: "h-[56px] rounded-8"
                                                })
                                            ]
                                        })
                                    ]
                                })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-10 flex justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoonLoader/* default */.Z, {
                                    size: isDesktop ? 45 : 20
                                })
                            })
                        ]
                    })
                ]
            }),
            shouldShowEmptyState && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pb-24 flex justify-start items-center px-16 md:px-0 gap-8 mt-16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "font-light items-center flex",
                                dangerouslySetInnerHTML: {
                                    __html: t("descriptionResult")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: handleReset,
                                className: "cursor-pointer block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* default */.Z, {
                                    size: 20,
                                    color: "#883CFF"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-16 md:px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_Section, {
                            tag: null,
                            data: currentRecommend,
                            title: isAnyFiltered || isKeywordsSearched ? tCourse("Rekomendasi Kursus Lainnya") : "",
                            section: 4,
                            emoji: "✨",
                            id: null,
                            isHidden: isHidden
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Tenant_HomeCard = (HomeCard);

;// CONCATENATED MODULE: ./src/modules/Tenant/KYC.tsx


const KYC = ({ selectedKYCTags , competencesKYC , handleTagClick , submitPreference , isLoading  })=>{
    const disableKYCSubmitBtn = isLoading ? "loading" : selectedKYCTags.length === 0 ? "disabled" : "active";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-h-[250px] overflow-auto",
                children: competencesKYC?.map((c, competenceIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex gap-12 px-24 items-center font-light cursor-pointer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-b2 text-neutral-60 font-medium mb-8",
                                    children: c.name + " (optional)"
                                })
                            }, c + Math.random()),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-wrap px-16 mb-12",
                                children: c.tags// .slice(0, displayMoreTags[competenceIndex] ? c.tags.length : 3)
                                .map((t, tagIndex)=>{
                                    const info = {
                                        parent: c.name,
                                        tag: t.name
                                    };
                                    const position = selectedKYCTags.indexOf(t.name) + 1;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center font-light cursor-pointer",
                                        onClick: ()=>handleTagClick(competenceIndex, tagIndex, info),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: `text-c1 m-4
                      font-medium px-12 py-8 border-2  line-clamp-2 rounded-full 
                      ${t.selected ? "bg-violet_main_to_dark_purple_surface text-white border-violet_main" : "text-neutral-80 border-neutral20_to_dark30"} flex items-center`,
                                            children: [
                                                t.selected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "rounded-[50%] w-16 h-16 mr-4 inline-block bg-white text-violet_main_to_dark_purple_surface",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "flex items-center justify-center",
                                                        children: position
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "inline-block",
                                                    children: t.name
                                                })
                                            ]
                                        })
                                    }, t + Math.random());
                                })
                            })
                        ]
                    }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-24",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    isFull: true,
                    state: disableKYCSubmitBtn,
                    onClick: ()=>submitPreference(false),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "(",
                            selectedKYCTags.length,
                            "/3) Simpan"
                        ]
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/modules/User/userApi.ts
var userApi = __webpack_require__(70292);
// EXTERNAL MODULE: ./src/components/Card/CardCourseWithLesson.tsx
var Card_CardCourseWithLesson = __webpack_require__(97216);
;// CONCATENATED MODULE: ./src/modules/Tenant/SectionMandatory.tsx














swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* FreeMode */.Rv
]);
const SectionMandatory = ({ courses , label , section , isHidden =null , ...props })=>{
    const [isLoading, setIsLoading] = (0,react.useState)(true);
    const currentUser = (0,Auth_authStore/* useAuthStore */.t)((state)=>state.currentUser);
    const [currData, setCurrData] = (0,react.useState)([]);
    const [page, setPage] = (0,react.useState)(1);
    const [limit, setLimit] = (0,react.useState)(3);
    const [totalData, setTotalData] = (0,react.useState)(-1);
    const [noMoreData, setNoMoreData] = (0,react.useState)(false);
    const getSectionMandatoryDetail = (0,homeTenantApi/* useGetSectionMandatoryDetail */.IG)();
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const [shuffledData, setShuffledData] = (0,react.useState)(null);
    const [setSelectedTitle, isShow, setIsShow, setDataSection, setLoading] = (0,modalSectionStore/* useModalSectionStore */.y)((state)=>[
            state.setSelectedTitle,
            state.isShow,
            state.setIsShow,
            state.setDataSection,
            state.setLoading
        ]);
    const fetchMyCourses = (data)=>{
        let newData = data.filter((item)=>{
            return !currData.some((existingItem)=>existingItem.id === item.id);
        });
        setCurrData((prev)=>[
                ...prev,
                ...newData
            ]);
        setTotalData(data?.length);
        setIsLoading(false);
    // getCourses.doFetch(
    //   {
    //     slug: currentUser?.referral,
    //     limit,
    //     mandatory: 1,
    //     page,
    //   },
    //   {
    //     onSuccess(data) {
    //       let newData = data?.data.filter((item) => {
    //         return !currData.some(
    //           (existingItem) => existingItem.id === item.id
    //         );
    //       });
    //       setCurrData((prev) => [...prev, ...newData]);
    //       setTotalData(data?.meta.total);
    //       setIsLoading(false);
    //     },
    //   }
    // );
    };
    const referralCode = (0,helper/* getCookie */.ej)("ref_code_gk") && (0,helper/* getCookie */.ej)("ref_code_gk") !== "null" ? (0,helper/* getCookie */.ej)("ref_code_gk") :  true ? new URLSearchParams(window.location.search).get("referral") : 0;
    const fetchSectionDetail = ()=>{
        getSectionMandatoryDetail.doFetch({
            slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : // ? referralCode
            currentUser?.referral,
            course_mandatory: props?.id
        }, {
            onSuccess (data) {
                setDataSection(data?.data[0].courses);
                setLoading(false);
            }
        });
    };
    let itemCounts = page * limit;
    if (page > 1) itemCounts = totalData;
    const displayedItems = [
        ...currData
    ].slice(0, itemCounts);
    const loginState = (0,Auth_authStore/* useAuthStore */.t)((state)=>state.loginState);
    const renderCount = (0,react.useRef)(0);
    (0,react.useEffect)(()=>{
        // console.log(courses);
        renderCount.current = renderCount.current + 1;
        if (renderCount.current === 2) {
            setLimit(9);
            return;
        }
        if (!noMoreData) {
            fetchMyCourses(courses);
        }
    }, [
        courses,
        page
    ]);
    (0,react.useEffect)(()=>{
        setPage(1);
    }, [
        limit
    ]);
    const showLess = displayedItems.length === totalData;
    const isDesktopView =  true && window.screen.width >= 480;
    const settings = {
        className: "swiper-customized",
        freeMode: isDesktopView,
        spaceBetween: 12,
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1.2,
                slidesPerGroup: 1.2
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            // when window width is >= 912px
            1200: {
                slidesPerView: 3,
                slidesPerGroup: 3
            }
        }
    };
    const buttonHandler = (type)=>{
        (0,amplitude/* trackEventGTM */.hk)({
            event: "b2b_homepage_course_more_a",
            property: {
                category_name: label,
                button_type: type,
                section: section
            }
        });
        (0,amplitude/* trackEventGA */.w7)({
            event: "b2b_homepage_course_more_a",
            property: {
                category_name: label,
                button_type: type,
                section: section
            }
        });
        (0,amplitude/* trackEventGTM */.hk)({
            event: "b2b_homepage_course_more_a",
            property: {
                category_name: label,
                button_type: type,
                section: section
            }
        });
        (0,amplitude/* trackEventGA */.w7)({
            event: "b2b_homepage_course_more_a",
            property: {
                category_name: label,
                button_type: type,
                section: section
            }
        });
        if (noMoreData && showLess) {
            setLimit(3);
            setPage(1);
            return;
        }
        setPage((p)=>p + 1);
    };
    (0,react.useEffect)(()=>{
        setNoMoreData(currData.length >= totalData);
    }, [
        currData
    ]);
    const isMobile =  true && window.innerWidth < 768;
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        if (currData.length > 0) {
            const shuffled = [
                ...currData
            ].sort(()=>Math.random() - 0.5);
            setShuffledData(shuffled);
        }
    }, [
        currData
    ]);
    const showedItems = shuffledData?.slice(0, 3);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-32 relative",
        children: [
            label ? // <h2
            //   onClick={() => buttonHandler("Section Title")}
            //   className="text-neutral-80 text-h4 font-medium mb-16 cursor-pointer"
            // >
            //   {label}
            // </h2>
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between md:justify-start gap-8 pr-16 py-20 xl-max:py-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-neutral-80 text-h4 font-medium " + (currData && currData.length > 3 ? "cursor-pointer" : ""),
                        onClick: ()=>{
                            if (currData && currData.length > 3) {
                                if (!isMobile) {
                                    setSelectedTitle(label);
                                    setIsShow(!isShow);
                                    fetchSectionDetail();
                                } else {
                                    router.push({
                                        pathname: "/section-detail/[id]",
                                        query: {
                                            id: props.id,
                                            section: "mandatory"
                                        }
                                    });
                                }
                            }
                        },
                        children: label
                    }),
                    currData && currData.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-4 text-b2 font-medium cursor-pointer text-violet_main_to_dark_purple_surface",
                        onClick: ()=>{
                            if (!isMobile) {
                                setSelectedTitle(label);
                                setIsShow(!isShow);
                                fetchSectionDetail();
                            } else {
                                router.push({
                                    pathname: "/section-detail/[id]",
                                    query: {
                                        id: props.id,
                                        section: "mandatory"
                                    }
                                });
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "hidden md:block",
                                children: t("viewAll")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrow/* IconArrow */.C, {
                                isCaret: true,
                                direction: "right",
                                color: "#883CFF"
                            })
                        ]
                    })
                ]
            }) : null,
            currData && currData.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: isDesktopView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    ...settings,
                    navigation: isDesktopView && currData.length > 4,
                    onSlideNextTransitionStart: (_)=>{
                        buttonHandler("Next Courses");
                    },
                    onSlidePrevTransitionStart: (_)=>{
                        buttonHandler("Previous Courses");
                    },
                    children: showedItems?.slice(0, 3).map((course, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonCircle */.s7, {}),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardCourseWithLesson["default"], {
                                    ...course,
                                    tracker: {
                                        event: "b2b_homepage_course_a",
                                        property: {
                                            course_name: course?.name,
                                            course_slug: course?.slug,
                                            institution_name: course?.institution?.name,
                                            category_name: label,
                                            section: label,
                                            index,
                                            is_mandatory_course: false
                                        }
                                    }
                                })
                            })
                        }, "Swiper-" + course.slug))
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `${isHidden !== null ? "px-16" : "px-0"} md:px-0 flex gap-12 overflow-x-scroll`,
                    children: currData.map((course, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonCircle */.s7, {}),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardCourseWithLesson["default"], {
                                ...course,
                                tracker: {
                                    event: "b2b_homepage_course_a",
                                    property: {
                                        course_name: course?.name,
                                        course_slug: course?.slug,
                                        institution_name: course?.institution?.name,
                                        category_name: label,
                                        section: label,
                                        index,
                                        is_mandatory_course: false
                                    }
                                },
                                wrapClass: "w-[300px] md:w-full"
                            })
                        }))
                })
            }) : null
        ]
    });
};
/* harmony default export */ var Tenant_SectionMandatory = (SectionMandatory);

// EXTERNAL MODULE: ./src/data/tenants/gerbangsari.json
var gerbangsari = __webpack_require__(4613);
// EXTERNAL MODULE: ./src/lib/tawk-to.ts
var tawk_to = __webpack_require__(2859);
// EXTERNAL MODULE: ./node_modules/@tawk.to/tawk-messenger-react/dist/tawk-messenger-react.es.js
var tawk_messenger_react_es = __webpack_require__(20075);
// EXTERNAL MODULE: ./src/components/Card/CardTenantMyClass.tsx
var CardTenantMyClass = __webpack_require__(59084);
;// CONCATENATED MODULE: ./src/modules/Tenant/CardContinue.tsx




const CardContinue = ({ onGoingCourses  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: onGoingCourses.length > 0 && onGoingCourses.map((course, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: {
                    pathname: "/course/[courseSlug]",
                    query: {
                        courseSlug: course.slug
                    }
                },
                onClick: ()=>{
                    (0,amplitude/* trackEventGTM */.hk)({
                        event: "b2b_homepage_course_a",
                        property: {
                            course_name: course?.name,
                            course_slug: course?.slug,
                            institution_name: course?.institution?.name,
                            remaining_time: course?.is_remaining_duration,
                            course_progress: (course?.enrollment_progress?.finished / course?.enrollment_progress?.total * 100).toString().slice(0, 4),
                            section: 0,
                            category_name: `Continue Your Course`,
                            index
                        }
                    });
                    (0,amplitude/* trackEventGA */.w7)({
                        event: "b2b_homepage_course_a",
                        property: {
                            course_name: course?.name,
                            course_slug: course?.slug,
                            institution_name: course?.institution?.name,
                            remaining_time: course?.is_remaining_duration,
                            course_progress: (course?.enrollment_progress?.finished / course?.enrollment_progress?.total * 100).toString().slice(0, 4),
                            section: 0,
                            category_name: `Continue Your Course`,
                            index
                        }
                    });
                    (0,amplitude/* trackEventGTM */.hk)({
                        event: "b2b_homepage_course_a",
                        property: {
                            course_name: course?.name,
                            course_slug: course?.slug,
                            institution_name: course?.institution?.name,
                            remaining_time: course?.is_remaining_duration,
                            course_progress: (course?.enrollment_progress?.finished / course?.enrollment_progress?.total * 100).toString().slice(0, 4),
                            section: 0,
                            category_name: `Continue Your Course`,
                            index
                        }
                    });
                    (0,amplitude/* trackEventGA */.w7)({
                        event: "b2b_homepage_course_a",
                        property: {
                            course_name: course?.name,
                            course_slug: course?.slug,
                            institution_name: course?.institution?.name,
                            remaining_time: course?.is_remaining_duration,
                            course_progress: (course?.enrollment_progress?.finished / course?.enrollment_progress?.total * 100).toString().slice(0, 4),
                            section: 0,
                            category_name: `Continue Your Course`,
                            index
                        }
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTenantMyClass/* CardTenantMyClass */.q, {
                    ...course,
                    height: 132,
                    isHomePage: true
                })
            }))
    });
};
/* harmony default export */ var Tenant_CardContinue = (CardContinue);

;// CONCATENATED MODULE: ./src/modules/Tenant/HomeCardKeywords.tsx













const HomeCardKeywords = ({ dataPaginate , data , isKeywordsSearched , pageKeywords , setPageKeywords , hasNextPage , setHasNextPage , isLoadingKeywords , setIsLoadingKeywords , itemsPerPage , startIndex , keywordOthers , intObserver , handleReset , isSquare , setCoursesAfterClicked  })=>{
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const { currentUser  } = (0,Auth_authStore/* useAuthStore */.t)((state)=>({
            currentUser: state.currentUser
        }));
    const subDomain = (0,ssr/* isBrowser */.j)() ? (0,host/* getSubDomain */.ZC)(window.location.hostname) : null;
    const isDesktop = (0,device/* useIsDesktop */.Ce)();
    // @ts-ignore
    const getCourses = (0,homeTenantApi/* useGetCoursesByTenantSlug */.HL)();
    let referral = (0,host/* useIsSubdomain */.Do)() ? currentUser?.referral ?? subDomain : currentUser?.referral;
    const observerRef = (0,react.useRef)();
    const activeKeywordName = (0,react.useMemo)(()=>keywordOthers.find((a)=>a.active)?.name, [
        keywordOthers
    ]);
    const referralCode = (0,helper/* getCookie */.ej)("ref_code_gk") && (0,helper/* getCookie */.ej)("ref_code_gk") !== "null" ? (0,helper/* getCookie */.ej)("ref_code_gk") :  true ? new URLSearchParams(window.location.search).get("referral") : 0;
    const [currentPage, setCurrentPage] = (0,react.useState)(1);
    const [mergedData, setMergedData] = (0,react.useState)([]);
    // Reset data ketika keyword berubah
    (0,react.useEffect)(()=>{
        setMergedData(data);
        setCurrentPage(1);
    }, [
        activeKeywordName
    ]);
    (0,react.useEffect)(()=>{
        if (!hasNextPage || !activeKeywordName) return;
        setIsLoadingKeywords(true);
        getCourses.doFetch({
            slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : referral,
            "others[]": [
                activeKeywordName
            ],
            limit: itemsPerPage.toString(),
            // @ts-ignore
            page: currentPage.toString()
        }, {
            onSuccess (data) {
                const paginate = data.meta.pagination;
                // Gabungkan data baru dengan data sebelumnya
                setMergedData((prev)=>{
                    // Filter untuk menghindari duplikat berdasarkan ID
                    const newData = data.data.filter((newItem)=>!prev.some((item)=>item.id === newItem.id));
                    return currentPage === 1 ? data.data : [
                        ...prev,
                        ...newData
                    ];
                });
                setHasNextPage(paginate.current_page < paginate.total_pages);
                setIsLoadingKeywords(false);
            },
            onError (error) {
                setIsLoadingKeywords(false);
            }
        });
    }, [
        currentPage,
        activeKeywordName,
        itemsPerPage,
        referral
    ]);
    const lastCard = (0,react.useCallback)((card)=>{
        if (isLoadingKeywords) return;
        if (observerRef.current) observerRef.current.disconnect();
        observerRef.current = new IntersectionObserver((cards)=>{
            if (cards[0].isIntersecting && hasNextPage) {
                setCurrentPage((prev)=>prev + 1);
            }
        });
        if (card) observerRef.current.observe(card);
    }, [
        isLoadingKeywords,
        hasNextPage
    ]);
    const courseContent = mergedData?.map((course, index)=>{
        const isLast = index === mergedData.length - 1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: isLast ? lastCard : null,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardCourseWithLesson["default"], {
                ...course,
                isSquare: isSquare,
                tracker: {
                    event: "b2b_homepage_course_a",
                    property: {
                        course_name: course?.name,
                        course_slug: course?.slug,
                        institution_name: course?.institution?.name,
                        section: 3,
                        category_name: `Default`,
                        index,
                        is_mandatory_course: false
                    }
                }
            })
        }, `${course.id}-${index}`);
    });
    if (isLoadingKeywords && data.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid-cols-3 xl-max:grid-cols-2 hg-max:!grid-cols-1 gap-20 justify-center grid",
                    children: [
                        ...Array(3)
                    ].map((_, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonWrapper */.nR, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                className: "w-full h-[214px] rounded-8"
                            })
                        }, idx))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex w-full p-24 items-center justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoonLoader/* default */.Z, {})
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-24 flex justify-start items-center px-16 md:px-0 gap-8 mt-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-light items-center flex",
                        dangerouslySetInnerHTML: {
                            __html: t("descriptionResultSearch", {
                                count: dataPaginate,
                                text: isKeywordsSearched,
                                additionalS: data?.length > 1 ? "s" : ""
                            })
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: handleReset,
                        className: "cursor-pointer block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* default */.Z, {
                            size: 20,
                            color: "#883CFF"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid-cols-3 xl-max:grid-cols-2 hg-max:!grid-cols-1 gap-20 justify-center grid",
                children: courseContent
            }),
            isLoadingKeywords && data.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid-cols-3 xl-max:grid-cols-2 hg-max:!grid-cols-1 gap-20 justify-center grid",
                        children: [
                            ...Array(3)
                        ].map((_, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonWrapper */.nR, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                    className: "w-full h-[214px] rounded-8"
                                })
                            }, idx))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-full p-24 items-center justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoonLoader/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Tenant_HomeCardKeywords = (HomeCardKeywords);

// EXTERNAL MODULE: ./src/components/Pagination/HorizontalScroll.tsx
var HorizontalScroll = __webpack_require__(53117);
;// CONCATENATED MODULE: ./src/modules/Tenant/Keywords.tsx










const Keywords = ({ setDataPaginate , pageKeywords , setPageKeywords , hasNextPage , setHasNextPage , isLoadingKeywords , setIsLoadingKeywords , itemsPerPage , keywordOthers , onReset , setKeywordOthers , setCoursesAfterClicked  })=>{
    const { currentUser  } = (0,Auth_authStore/* useAuthStore */.t)((state)=>({
            loginState: state.loginState,
            currentUser: state.currentUser
        }));
    const subDomain = (0,ssr/* isBrowser */.j)() ? (0,host/* getSubDomain */.ZC)(window.location.hostname) : null;
    const router = (0,next_router.useRouter)();
    const isMobileView =  true && window.innerWidth < 768;
    //   @ts-ignore
    const getCourses = (0,homeTenantApi/* useGetCoursesByTenantSlug */.HL)();
    let referral = (0,host/* useIsSubdomain */.Do)() ? currentUser?.referral ?? subDomain : currentUser?.referral;
    const referralCode = (0,helper/* getCookie */.ej)("ref_code_gk") && (0,helper/* getCookie */.ej)("ref_code_gk") !== "null" ? (0,helper/* getCookie */.ej)("ref_code_gk") :  true ? new URLSearchParams(window.location.search).get("referral") : 0;
    const handleKeywordClick = (keys)=>{
        onReset?.();
        setPageKeywords(1);
        setCoursesAfterClicked?.([]);
        setHasNextPage(true);
        const updatedKeywords = keywordOthers.map((el)=>el.name === keys.name ? {
                ...el,
                active: !el.active
            } : {
                ...el,
                active: false
            });
        setKeywordOthers?.(updatedKeywords);
        const activeKeyword = updatedKeywords.find((k)=>k.active);
        if (activeKeyword) {
            router.push({
                pathname: "/"
            }, undefined, {
                shallow: true
            });
            if (referral && ![
                "moodle",
                "example"
            ].includes(referral)) {
                setIsLoadingKeywords(true);
                getCourses.doFetch({
                    slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : referral,
                    "others[]": [
                        activeKeyword.name
                    ],
                    limit: itemsPerPage.toString(),
                    // @ts-ignore
                    page: 1
                }, {
                    onSuccess (data) {
                        const paginate = data.meta.pagination;
                        setCoursesAfterClicked?.(data.data);
                        setDataPaginate(data.meta.total);
                        setHasNextPage(paginate.current_page < paginate.total_pages);
                        setIsLoadingKeywords(false);
                    },
                    onError (error) {
                        setIsLoadingKeywords(false);
                    }
                });
            }
        }
        (0,amplitude/* trackEventGTM */.hk)({
            event: "keyword_chip_a",
            property: {
                user_id: currentUser?.id ?? "",
                is_logged_in: !!currentUser,
                keyword_name: keys.name
            }
        });
        (0,amplitude/* trackEventGA */.w7)({
            event: "keyword_chip_a",
            property: {
                user_id: currentUser?.id ?? "",
                is_logged_in: !!currentUser,
                keyword_name: keys.name
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalScroll/* HorizontalScroll */.Z, {
        className: "md:mb-0 !gap-0",
        paddingHorizontal: 0,
        top: 12,
        useNavigation: !isMobileView,
        children: keywordOthers.map((keys)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `border rounded-full cursor-pointer px-12 py-8 text-center inline-flex flex-row items-center min-w-12 whitespace-nowrap m-8 ml-0 mr-8 md:mr-10 text-b2 font-light ${keys.active ? "bg-violet_main_to_dark_purple_surface text-white_to_white border-violet_main" : "border-light_neutral10_to_dark_neutral50 text-neutral80_to_dark10 bg-light_neutral10_to_dark_neutral50"}`,
                onClick: ()=>handleKeywordClick(keys),
                children: keys.name
            }, keys.name))
    });
};
/* harmony default export */ var Tenant_Keywords = (Keywords);

// EXTERNAL MODULE: ./src/modules/Tenant/ModalSectionsDetail.tsx
var ModalSectionsDetail = __webpack_require__(16120);
// EXTERNAL MODULE: ./src/lib/course.ts
var course = __webpack_require__(37424);
// EXTERNAL MODULE: ./src/modules/Bundle/bundleApi.ts
var bundleApi = __webpack_require__(82084);
;// CONCATENATED MODULE: ./src/modules/Course/UserRecomendations.tsx













const COURSE_RECOM_PER_LOAD = 9;
const UserRecomendations = ({ sliced =false , startSlice =0 , endSlice =0 , isLast =false , isSquare =false  })=>{
    const isDesktop = (0,device/* useIsDesktop */.Ce)();
    const router = (0,next_router.useRouter)();
    const getRecommendationsCourses = (0,homeTenantApi/* useGetCoursesUserRecomendations */.Ao)();
    const courseSlug = typeof router.query.courseSlug == "string" ? router.query.courseSlug : "";
    const lessonSlug = typeof router.query.lesson == "string" ? router.query.lesson : "";
    const { currentUser  } = (0,Auth_authStore/* useAuthStore */.t)((state)=>({
            currentUser: state.currentUser
        }));
    const accessCourseApi = (0,exploreApi/* useAccessCourseTenant */.le)();
    const [listForbidden, setListForbidden] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        accessCourseApi.doFetch({
            // @ts-ignore
            slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : currentUser?.referral
        }, {
            onSuccess (data) {
                const userId = currentUser?.id;
                const accessData = data?.data || [];
                const forbiddenList = [];
                accessData.forEach((course)=>{
                    if (course.user !== userId) {
                        if (Array.isArray(course.courses)) {
                            course.courses.forEach((c)=>{
                                if (c?.slug) forbiddenList.push(c.slug);
                            });
                        } else if (course.courses?.slug) {
                            forbiddenList.push(course.courses.slug);
                        }
                    }
                });
                setListForbidden(forbiddenList);
            },
            onError (err) {
                ;
            }
        });
    }, [
        currentUser
    ]);
    // For tracker purpose
    const [currentLesson, courseStatus, courseEnrollmentId] = (0,courseStore/* useCourseStore */.Kt)((state)=>[
            state.currentLesson,
            state.courseStatus,
            state.courseEnrollmentId
        ]);
    const [page, setPage] = (0,react.useState)(1);
    const [recomData, setRecommendData] = (0,react.useState)([]);
    const [hasNextPage, setHasNextPage] = (0,react.useState)(true);
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const intObserver = (0,react.useRef)();
    const isB2B = (0,host/* useIsSubdomain */.Do)() || (0,host/* useIsTenant */.we)();
    // data for pagination
    const itemsPerPage = 6;
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const referralCode = (0,helper/* getCookie */.ej)("ref_code_gk") && (0,helper/* getCookie */.ej)("ref_code_gk") !== "null" ? (0,helper/* getCookie */.ej)("ref_code_gk") :  true ? new URLSearchParams(window.location.search).get("referral") : 0;
    (0,react.useEffect)(()=>{
        if (isB2B && currentUser) {
            if (!hasNextPage) {
                return;
            } else {
                setIsLoading(true);
                getRecommendationsCourses.doFetch({
                    slug: currentUser?.referral,
                    page,
                    limit: isDesktop ? 6 : 12
                }, {
                    onSuccess (data) {
                        const paginate = data.meta.pagination;
                        setTimeout(()=>{
                            // @ts-ignore
                            setRecommendData((prevItems)=>[
                                    ...prevItems,
                                    ...data?.data
                                ]);
                            setHasNextPage(Boolean(paginate.current_page < paginate.total_pages));
                            setIsLoading(false);
                        }, 500);
                    },
                    onError (data) {
                        setIsLoading(false);
                    }
                });
                if (page > 1 && hasNextPage) {
                    const bodyEvent = {
                        // Current Page (page 1 won't be track and
                        // make to page 2 as page 1)
                        load: page - 1,
                        course_slug: courseSlug,
                        lesson_slug: currentLesson?.slug,
                        course_enrollment_id: courseEnrollmentId,
                        type: currentLesson?.type,
                        lesson_num: (0,courseStore/* getLessonNumberBySlug */.OA)(currentLesson?.slug, courseStatus),
                        lesson_id: (0,courseStore/* getLessonIdBySlug */.P_)(courseStatus?.chapters, lessonSlug)?.lessonId,
                        chapter_num: (0,courseStore/* getLessonIdBySlug */.P_)(courseStatus?.chapters, lessonSlug)?.chapterNum,
                        course_id: courseStatus?.id
                    };
                }
            }
        }
    }, [
        page,
        currentUser,
        isB2B,
        referralCode
    ]);
    const lastCard = (0,react.useCallback)((card)=>{
        if (isLoading) return;
        if (intObserver.current) intObserver.current.disconnect();
        intObserver.current = new IntersectionObserver((cards)=>{
            if (cards[0].isIntersecting && hasNextPage) {
                setPage((prev)=>prev + 1);
            }
        });
        if (card) intObserver.current.observe(card);
    }, [
        isLoading,
        hasNextPage
    ]);
    const filteredData = recomData.filter((course)=>!listForbidden.includes(course.slug));
    const slicedData = sliced ? filteredData.slice(startSlice, endSlice || undefined) : filteredData;
    const recommendContent = slicedData.map((course, idx)=>{
        if (slicedData.length === idx + 1 && isLast) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: lastCard,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardCourseWithLesson["default"], {
                    ...course,
                    isRecommendPage: true,
                    isSquare: isSquare
                })
            }, course.id || idx);
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardCourseWithLesson["default"], {
                ...course,
                isRecommendPage: true,
                isSquare: isSquare
            }, course.id || idx);
        }
    });
    ;
    if (recomData.length > 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `md:p-16 grid pl-0 grid-cols-3 gap-20 xl-max:grid-cols-2 xl:pl-16 sm-max:!grid-cols-1 sm-max:px-0 sm-max:py-16`,
                    children: recommendContent
                }),
                isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonWrapper */.nR, {
                    className: "lg:grid lg:grid-cols-3 gap-x-12 mt-56",
                    children: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6
                    ].map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                            className: "h-[200px] rounded-8 w-full mb-24"
                        }, el))
                })
            ]
        });
    }
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonWrapper */.nR, {
            className: "lg:grid lg:grid-cols-3 gap-x-12 mt-56",
            children: [
                1,
                2,
                3,
                4,
                5,
                6
            ].map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                    className: "h-[200px] rounded-8 w-full mb-24"
                }, el))
        });
    }
};

// EXTERNAL MODULE: ./src/components/Card/CardCourseBundle.tsx
var CardCourseBundle = __webpack_require__(87948);
;// CONCATENATED MODULE: ./src/modules/Tenant/SectionBundles.tsx











swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* FreeMode */.Rv
]);
const SectionBundles = ({ bundles , section , isHidden =null , ...props })=>{
    const [currData, setCurrData] = (0,react.useState)(bundles);
    const [page, setPage] = (0,react.useState)(1);
    const [limit, setLimit] = (0,react.useState)(3);
    const [totalData, setTotalData] = (0,react.useState)(-1);
    const [noMoreData, setNoMoreData] = (0,react.useState)(false);
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const [shuffledData, setShuffledData] = (0,react.useState)(null);
    const [setSelectedTitle, isShowBundle, setIsShowBundle, setDataSection, setLoading] = (0,modalSectionStore/* useModalSectionStore */.y)((state)=>[
            state.setSelectedTitle,
            state.isShowBundle,
            state.setIsShowBundle,
            state.setDataSection,
            state.setLoading
        ]);
    const fetchSectionDetail = ()=>{
        setDataSection(bundles);
        setLoading(false);
    };
    let itemCounts = page * limit;
    if (page > 1) itemCounts = totalData;
    const displayedItems = [
        ...currData
    ].slice(0, itemCounts);
    const renderCount = (0,react.useRef)(0);
    (0,react.useEffect)(()=>{
        renderCount.current = renderCount.current + 1;
        if (renderCount.current === 2) {
            setLimit(9);
            return;
        }
    }, [
        bundles,
        page
    ]);
    (0,react.useEffect)(()=>{
        setPage(1);
    }, [
        limit
    ]);
    const showLess = displayedItems.length === totalData;
    const isDesktopView =  true && window.screen.width >= 480;
    const settings = {
        className: "swiper-customized",
        freeMode: isDesktopView,
        spaceBetween: 12,
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1.2,
                slidesPerGroup: 1.2
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            // when window width is >= 912px
            1200: {
                slidesPerView: 3,
                slidesPerGroup: 3
            }
        }
    };
    const buttonHandler = (type)=>{
        (0,amplitude/* trackEventGTM */.hk)({
            event: "b2b_homepage_course_more_a",
            property: {
                category_name: "Learning Paths",
                button_type: type,
                section: section
            }
        });
        (0,amplitude/* trackEventGA */.w7)({
            event: "b2b_homepage_course_more_a",
            property: {
                category_name: "Learning Paths",
                button_type: type,
                section: section
            }
        });
        if (noMoreData && showLess) {
            setLimit(3);
            setPage(1);
            return;
        }
        setPage((p)=>p + 1);
    };
    (0,react.useEffect)(()=>{
        setNoMoreData(currData.length >= totalData);
    }, [
        currData
    ]);
    const isMobile =  true && window.innerWidth < 768;
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        if (currData.length > 0) {
            const shuffled = [
                ...currData
            ].sort(()=>Math.random() - 0.5);
            setShuffledData(shuffled);
        }
    }, [
        currData
    ]);
    const showedItems = shuffledData?.slice(0, 3);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-32 relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between md:justify-start gap-8 pr-16 py-20 xl-max:py-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-neutral-80 text-h4 font-medium " + (currData && currData.length > 3 ? "cursor-pointer" : ""),
                        onClick: ()=>{
                            if (currData && currData.length > 3) {
                                if (!isMobile) {
                                    setSelectedTitle("Learning Paths");
                                    setIsShowBundle(!isShowBundle);
                                    fetchSectionDetail();
                                } else {
                                    router.push({
                                        pathname: "/section-detail/[id]",
                                        query: {
                                            id: props.id,
                                            section: "mandatory"
                                        }
                                    });
                                }
                            }
                        },
                        children: "Learning Paths"
                    }),
                    currData && currData.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-4 text-b2 font-medium cursor-pointer text-violet_main_to_dark_purple_surface",
                        onClick: ()=>{
                            if (!isMobile) {
                                setSelectedTitle("Learning Paths");
                                setIsShowBundle(!isShowBundle);
                                fetchSectionDetail();
                            } else {
                                router.push({
                                    pathname: "/section-detail/[id]",
                                    query: {
                                        id: props.id,
                                        section: "mandatory"
                                    }
                                });
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "hidden md:block",
                                children: t("viewAll")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrow/* IconArrow */.C, {
                                isCaret: true,
                                direction: "right",
                                color: "#883CFF"
                            })
                        ]
                    })
                ]
            }),
            currData && currData.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: isDesktopView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    ...settings,
                    navigation: isDesktopView && currData.length > 4,
                    onSlideNextTransitionStart: (_)=>{
                        buttonHandler("Next Courses");
                    },
                    onSlidePrevTransitionStart: (_)=>{
                        buttonHandler("Previous Courses");
                    },
                    children: showedItems?.slice(0, 3).map((course, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonCircle */.s7, {}),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCourseBundle/* default */.Z, {
                                    ...course,
                                    isBundles: true,
                                    tracker: {
                                        event: "b2b_homepage_course_a",
                                        property: {
                                            course_name: course?.name,
                                            course_slug: course?.slug,
                                            institution_name: course?.institution?.name,
                                            category_name: "Learning Paths",
                                            section: "Learning Paths",
                                            index,
                                            is_mandatory_course: false
                                        }
                                    }
                                })
                            })
                        }, "Swiper-" + course.slug);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `${isHidden !== null ? "px-16" : "px-0"} md:px-0 flex gap-12 overflow-x-scroll`,
                    children: currData.map((course, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonCircle */.s7, {}),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCourseBundle/* default */.Z, {
                                ...course,
                                isBundles: true,
                                tracker: {
                                    event: "b2b_homepage_course_a",
                                    property: {
                                        course_name: course?.name,
                                        course_slug: course?.slug,
                                        institution_name: course?.institution?.name,
                                        category_name: "Learning Paths",
                                        section: "Learning Paths",
                                        index,
                                        is_mandatory_course: false
                                    }
                                },
                                wrapClass: "w-[300px] md:w-full"
                            })
                        }))
                })
            }) : null
        ]
    });
};
/* harmony default export */ var Tenant_SectionBundles = (SectionBundles);

;// CONCATENATED MODULE: ./src/modules/Tenant/index.tsx













































const HomeTenant = ({ textValue =null  })=>{
    const [hasMoreMandatory, setHasMoreMandatory] = (0,react.useState)(true);
    const [pageMandatory, setPageMandatory] = (0,react.useState)(1);
    const domain =  true && window.location.hostname;
    // const [page, setPage] = useState({
    //   page: 1,
    // });
    const { currentUser  } = (0,Auth_authStore/* useAuthStore */.t)((state)=>({
            loginState: state.loginState,
            currentUser: state.currentUser
        }));
    const [searchText, setSearch] = (0,react.useState)(null);
    const router = (0,next_router.useRouter)();
    const [currentSort, setCurrentSort] = (0,react.useState)({});
    const [filters, setFilters] = useStateWithMemo({});
    const [maxItem, setMaxItem] = (0,react.useState)(0);
    const [sortDesc, setSortByDesc] = (0,react.useState)(null);
    const [isLoader, setIsLoader] = (0,react.useState)(false);
    const isSubdomainTenant = (0,host/* useIsSubdomain */.Do)();
    const [show, setShow] = (0,react.useState)(true);
    const isDesktop = (0,device/* useIsDesktop */.Ce)();
    const isSearchPage = router?.pathname.includes("search");
    const [categories, setCategories] = (0,react.useState)([]);
    const [allIns, setInstitutions] = (0,react.useState)([]);
    const [competencesFilter, setCompetencesFilter] = (0,react.useState)([]);
    const [competencesKYC, setCompetencesKYC] = (0,react.useState)([]);
    const [showKYC, setShowKYC] = (0,react.useState)(false);
    const [screenWidth, setScreenWidth] = (0,react.useState)(1200);
    const [selectedKYCTags, setKYCTags] = (0,react.useState)([]);
    const [onGoingCourses, setOnGoingCourses] = (0,react.useState)([]);
    const [keywordOthers, setKeywordOthers] = (0,react.useState)([]);
    const [coursesAfterKeywordClicked, setCoursesAfterClicked] = (0,react.useState)([]);
    const [dataPaginate, setDataPaginate] = (0,react.useState)({});
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const myClassAPI = (0,myClassApi/* useMyClassApi */.ph)();
    const [isDoneFetching, setFetching] = (0,react.useState)(false);
    const [mandatoryCourses, setMandatoryCourses] = (0,react.useState)([]);
    // const notifications = useGetNotificationApi();
    const { mandatoryCount  } = (0,courseStore/* useCourseStore */.Kt)((s)=>({
            mandatoryCount: s.mandatoryCount
        }));
    const tabsId = router.query.tabsId ?? null;
    const getSectionCustom = (0,homeTenantApi/* useGetSectionCustomByTenantSlug */.J7)(currentUser?.referral);
    const getCourseMandatory = (0,homeTenantApi/* useGetCoursesMandatoryByTenantSlug */.ie)(currentUser?.referral);
    const getOthers = (0,homeTenantApi/* useGetOthersByTenantSlug */.Zr)();
    const [sectionPosition, setSectionPosition] = (0,react.useState)([]);
    const [sectionB2B, setSectionB2B] = (0,react.useState)([]);
    const [sectionMandatory, setSectionMandatory] = (0,react.useState)([]);
    const [sectionsMandatory, setSectionsMandatory] = (0,react.useState)([]);
    const getCoursesByTenantSlug = (0,homeTenantApi/* useGetCoursesByTenantSlug */.HL)();
    const [pageKeywords, setPageKeywords] = (0,react.useState)(1);
    const [hasNextPage, setHasNextPage] = (0,react.useState)(true);
    const [isLoadingKeywords, setIsLoadingKeywords] = (0,react.useState)(false);
    // data for pagination
    const itemsPerPage = 9;
    const startIndex = (pageKeywords - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const { totalFilter , setTotalFilter , popularCourse , setPopularCourse , keywords , setKeywords , indexName  } = (0,searchStore/* useSearchStore */.R)((state)=>({
            totalFilter: state.totalFilter,
            setTotalFilter: state.setTotalFilter,
            popularCourse: state.popularCourse,
            setPopularCourse: state.setPopularCourse,
            keywords: state.keywords,
            setKeywords: state.setKeywords,
            indexName: state.indexName
        }));
    const isMobileView =  true && window.innerWidth < 768;
    const onReset = ()=>{
        setPage(1);
        setSortByDesc("");
        setFilters({});
        setCurrentSort({});
    };
    //@ts-ignore
    const exploreCompetences = (0,exploreApi/* useCompetenciesTenant */.E8)();
    const modifytags = (arr)=>{
        return arr.map((item)=>{
            const transformedTags = item.tags.filter((a)=>!a.total_courses || a.total_courses > 0).map((tag)=>({
                    ...tag,
                    selected: false
                }));
            return {
                name: item.name,
                selected: false,
                slug: item.slug,
                tags: transformedTags
            };
        });
    };
    const subDomain = (0,ssr/* isBrowser */.j)() ? (0,host/* getSubDomain */.ZC)(window.location.hostname) : null;
    const referral = isSubdomainTenant ? currentUser?.referral ?? subDomain : currentUser?.referral;
    const referralCode = (0,helper/* getCookie */.ej)("ref_code_gk") && (0,helper/* getCookie */.ej)("ref_code_gk") !== "null" ? (0,helper/* getCookie */.ej)("ref_code_gk") :  true ? new URLSearchParams(window.location.search).get("referral") : 0;
    (0,react.useEffect)(()=>{
        if (referral) {
            exploreCompetences.doFetch({
                slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : // ? referralCode
                referral
            }, {
                onSuccess (res) {
                    const filterData = modifytags(res.data);
                    const KYC = modifytags(res.data);
                    setCompetencesFilter(filterData.filter((a)=>a.tags.length > 0));
                    setCompetencesKYC(KYC);
                }
            });
            // Show Tawk To
            (0,tawk_to/* checkTawkTo */.A)(currentUser);
        }
    }, [
        referral,
        referralCode
    ]);
    (0,react.useEffect)(()=>{
        if (currentUser && !currentUser?.has_kyc_submitted && competencesKYC.length > 0 && // Hide KYC if Tenant Section exist (4/4/24)
        sectionPosition.length === 0) {
            const plan = (currentUser?.tenant)?.plan?.name;
            const screen =  true && window.innerWidth;
            if ([
                "Enterprise Plus",
                "Enterprise"
            ].includes(plan)) {
                setShowKYC(true);
            }
            setScreenWidth(screen);
        }
    }, [
        competencesKYC,
        sectionPosition
    ]);
    (0,react.useEffect)(()=>{
        if (showKYC) {
            // @ts-ignore
            (0,amplitude/* trackEventGTM */.hk)({
                event: "myinterest_s"
            });
            // @ts-ignore
            (0,amplitude/* trackEventGA */.w7)({
                event: "myinterest_s"
            });
        }
    }, [
        showKYC
    ]);
    (0,react.useEffect)(()=>{
        if (currentUser) {
            myClassAPI.doFetch({
                status: "on_progress",
                // @ts-ignore
                limit: 12,
                // @ts-ignore
                page: 1
            }, {
                onSuccess (res) {
                    setOnGoingCourses(res?.data.filter((el)=>el.enrollment_status == "on_progress").slice(0, 3));
                }
            });
        }
    }, [
        currentUser
    ]);
    (0,react.useEffect)(()=>{
        // if (referral && sectionB2B.length === 0) {
        //   const plan = currentUser?.tenant?.plan?.name;
        //   let currentTags = [];
        //   if (referral === "arwanacitra") {
        //     currentTags = mapTagsToSection([
        //       "Personal Development",
        //       "Performance & Productivity",
        //       "Entrepreneurship",
        //     ]);
        //   } else if (gerbangsari.includes(referral)) {
        //     currentTags = mapTagsToSection(SECTION_GERBANGSARI);
        //   } else {
        //     if(loginState == 'LOGIN') {
        //       if (currentUser.list_tags && currentUser?.list_tags?.length > 0) {
        //         currentTags = mapArrayToSection((currentUser as any)?.list_tags);
        //       } else {
        //         switch (plan) {
        //           case "Enterprise Plus":
        //             currentTags = SECTION_PLUS;
        //             break;
        //           case "Pro":
        //             currentTags = SECTION_PRO;
        //             break;
        //           default:
        //             currentTags = SECTION_BASIC;
        //             break;
        //         }
        //       }
        //     } else {
        //       currentTags = SECTION_BASIC;
        //     }
        //   }
        //   setSectionB2B(currentTags);
        // }
        let currentTags = [];
        // Gerbangsari default sections
        if (gerbangsari.includes(referral)) {
            currentTags = mapTagsToSection(SECTION_GERBANGSARI);
        } else if ( true && (0,host/* isMalukuURL */.U)(window.location.hostname)) {
            currentTags = mapTagsToSection(SECTION_MALUKU);
        } else {
            // Default sections for paid & free trial (22/3/24) - reproduced: 28/3/24
            currentTags = mapTagsToSection([
                "Personal Development",
                "Performance & Productivity",
                "Leadership & Management"
            ]);
        }
        /// Section according to KYC (4/4/24)
        if (currentUser?.list_tags && currentUser?.list_tags?.length > 0) {
            currentTags = mapArrayToSection(currentUser?.list_tags);
        }
        setSectionB2B(currentTags);
    }, [
        currentUser
    ]);
    const loadMoreMandatory = (0,react.useCallback)(()=>{
        setPageMandatory((prevState)=>prevState + 1);
    }, []);
    const lastMandatoryCourseElm = lib_useInfiniteScroll(loadMoreMandatory, hasMoreMandatory, isLoader);
    const updateText = (text)=>setSearch(text);
    const debouncedOnChange = lodash_debounce_default()(updateText, 800);
    const openModal = ()=>{
        (0,amplitude/* trackEvent */.L9)({
            event: "srp_filter_open_a",
            property: {
                page: `B2B Homepage`
            }
        });
        setShow(false);
    };
    const skeleton = isDesktop ? [
        1,
        2,
        3
    ] : [
        1
    ];
    const skeletonHeader = isDesktop ? [
        1,
        2
    ] : [
        1
    ];
    const skeletonFilter = isDesktop ? [
        1,
        2,
        3,
        4
    ] : [
        1
    ];
    const skeletonMandatory = isDesktop ? [
        1,
        2,
        3,
        4
    ] : [
        1
    ];
    const continueYourCourses = t("continue");
    const q = router?.query?.q ?? null;
    const institutionKeyFilter = typeof router.query.institutionKey == "string" ? router.query.institutionKey : null;
    const tagsKeyFilter = typeof router.query.tagsKey == "string" ? router.query.tagsKey : null;
    const sortByFilter = typeof router.query.sortBy == "string" ? router.query.sortBy : null;
    const institutionName = typeof router.query.institutionName == "string" ? router.query.institutionName : null;
    const isHidden = institutionName || tagsKeyFilter || institutionKeyFilter || q || sortByFilter;
    const [activeTab, setActiveTab] = (0,react.useState)("mandatory");
    const renderCount = (0,react.useRef)(0);
    const [page, setPage] = (0,react.useState)(1);
    const [limit, setLimit] = (0,react.useState)(3);
    const loginState = (0,Auth_authStore/* useAuthStore */.t)((state)=>state.loginState);
    (0,react.useEffect)(()=>{
        renderCount.current = renderCount.current + 1;
        if (renderCount.current > 1) {
            (0,amplitude/* trackEventGTM */.hk)({
                event: "b2b_homepage_s",
                property: {
                    has_mandatory_course: mandatoryCourses.length > 0 ? true : false,
                    language: router?.locale
                }
            });
            (0,amplitude/* trackEventGA */.w7)({
                event: "b2b_homepage_s",
                property: {
                    has_mandatory_course: mandatoryCourses.length > 0 ? true : false,
                    language: router?.locale
                }
            });
        }
    // if (mandatoryCount !== 0) {
    //   setSectionMandatory(SECTION_MANDATORY);
    // }
    }, [
        mandatoryCount
    ]);
    (0,react.useEffect)(()=>{
        if (mandatoryCount === 0) {
            setFetching(true);
            return;
        }
    }, [
        pageMandatory,
        mandatoryCount,
        currentUser
    ]);
    (0,react.useEffect)(()=>{
        if (referral) {
            // Fetch custom section
            getSectionCustom.doFetch({
                slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : // ? referralCode
                referral
            }, {
                onSuccess (data) {
                    // console.log(data);
                    setSectionPosition(data.data);
                }
            });
            // Fetch others
            getOthers.doFetch({
                slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : // ? referralCode
                referral
            }, {
                onSuccess (data) {
                    setKeywordOthers(data?.data.map((el)=>{
                        return {
                            ...el,
                            active: false
                        };
                    }));
                }
            });
        }
    }, [
        referral,
        referralCode
    ]);
    (0,react.useEffect)(()=>{
        if (loginState === "LOGIN" && currentUser) {
            getCourseMandatory.doFetch({
                slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : // ? referralCode
                currentUser?.referral
            }, {
                onSuccess (data) {
                    // console.log(data);
                    let filteredData = data.data.filter((a)=>a.courses.length > 0);
                    setSectionsMandatory(filteredData);
                }
            });
        }
    }, [
        loginState,
        referralCode
    ]);
    // useEffect(() => {
    //   // Sort section based on sectionPosition
    //   if(sectionB2B.length > 0 && sectionPosition.length > 0){
    //     // Sort position based on sort field
    //     const sortedArray = sectionPosition.sort((a, b) => a.sort - b.sort);
    //     // Flatten the title of section
    //     const sectionTitle = sortedArray.map(item => item.title)
    //     // Format into section
    //     const newSection = mapTagsToSection(sectionTitle)
    //     // Set new section
    //     setSectionB2B(newSection);
    //   }
    // }, [sectionPosition]);
    const handleTagClick = (competenceIndex, tagIndex, info)=>{
        const { parent ="" , tag =""  } = info;
        (0,amplitude/* trackEvent */.L9)({
            event: "myinterest_select_a",
            property: {
                selected_type: parent,
                selected_value: tag
            }
        });
        const updatedCompetences = [
            ...competencesKYC
        ];
        const selectedTag = updatedCompetences[competenceIndex].tags[tagIndex];
        selectedTag.selected = !selectedTag.selected;
        const selectedTagsCount = competencesKYC.flatMap((comp)=>comp.tags.filter((tag)=>tag.selected)).length;
        if (selectedTagsCount > 3) {
            selectedTag.selected = !selectedTag.selected;
        } else {
            setCompetencesKYC(updatedCompetences);
        }
    };
    (0,react.useEffect)(()=>{
        const selectedTags = competencesKYC.flatMap((comp)=>comp.tags.filter((tag)=>tag.selected)).map((t)=>t.name);
        setKYCTags(selectedTags);
    }, [
        competencesKYC
    ]);
    const userPreferenceApi = (0,userApi/* useUserPreference */.Iw)();
    const userGetProfile = (0,userApi/* useUserGetProfile */.cw)();
    const authStore = (0,Auth_authStore/* useAuthStore */.t)();
    const submitPreference = (isClose = false)=>{
        if (!isClose) {
            (0,amplitude/* trackEvent */.L9)({
                event: "myinterest_submit_a",
                property: {
                    submitted_values: selectedKYCTags
                }
            });
            setSectionB2B([]);
        }
        userPreferenceApi.doFetch({
            tags: isClose ? [] : selectedKYCTags
        }, {
            onSuccess (data) {
                setShowKYC(false);
                if (!isClose) {
                    const sections = mapArrayToSection(data?.data);
                    setSectionB2B(sections);
                    (0,amplitude/* trackEvent */.L9)({
                        event: "myinterest_submit_success_a",
                        property: {
                            submitted_values: selectedKYCTags
                        }
                    });
                }
                /// Hit CurrentUser API to update the kyc_submitted
                userGetProfile.doFetch({}, {
                    onSuccess (res) {
                        authStore.setLogin(res.data);
                    }
                });
            },
            onError (e) {
                setShowKYC(false);
            }
        });
    };
    const isMobile = screenWidth < 768;
    const tawkMessengerRef = (0,react.useRef)();
    const onChatMinimized = ()=>{
        (0,amplitude/* trackEvent */.L9)({
            event: "chatbot_close_a",
            property: {
                email: currentUser?.email ?? "none"
            }
        });
    };
    const onChatMaximized = ()=>{
        (0,amplitude/* trackEvent */.L9)({
            event: "chatbot_open_a",
            property: {
                email: currentUser?.email ?? "none"
            }
        });
    };
    const onChatMessageVisitor = (message)=>{
        (0,amplitude/* trackEvent */.L9)({
            event: "chatbot_user_chat_a",
            property: {
                email: currentUser?.email ?? "none",
                message: message?.message
            }
        });
    };
    const onFileUpload = (link)=>{
        (0,amplitude/* trackEvent */.L9)({
            event: "chatbot_user_upload_a",
            property: {
                email: currentUser?.email ?? "none",
                link: link
            }
        });
    };
    const onLoad = ()=>{
    // const properties = {
    //   name : currentUser?.name ?? 'none',
    //   email : currentUser?.email ?? 'none'
    // }
    // console.log("onload...:",properties)
    };
    /// Dev Tawk To (cs@gokampus.com)
    // const tawkPropertyId = "65f2aa7a9131ed19d979bd5c"
    // const tawkWidgetId = "1hotujt03"
    const [isShowTawkTo, setIsShowTawkTo] = (0,react.useState)(false);
    const [tawkPropertyId, settawkPropertyId] = (0,react.useState)("");
    const [tawkWidgetId, settawkWidgetId] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        if (currentUser?.referral === "kemenperin" || currentUser?.referral === "gok-moodle") {
            /// Kemenperin Tawk To (cs2@gokampus.com)
            settawkPropertyId("660d5b1f1ec1082f04de6876");
            settawkWidgetId("1hqi2ntsc");
            setIsShowTawkTo(true);
        } else {
            settawkPropertyId("");
            settawkWidgetId("");
            setIsShowTawkTo(false);
        }
    }, [
        currentUser
    ]);
    const [isScrolled, setIsScrolled] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const handleScroll = ()=>setIsScrolled(window.scrollY > 0);
        window.addEventListener("scroll", handleScroll);
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, []);
    (0,react.useEffect)(()=>{
        if (isScrolled) {
            (0,amplitude/* trackEventGTM */.hk)({
                event: "b2b_homepage_scroll_a"
            });
            (0,amplitude/* trackEventGA */.w7)({
                event: "b2b_homepage_scroll_a"
            });
        }
    }, [
        isScrolled
    ]);
    (0,react.useEffect)(()=>{
        // if any filter selected on sidebar, keywords will be inactive
        if (isHidden && keywordOthers.length) {
            setKeywordOthers(keywordOthers.map((el)=>({
                    ...el,
                    active: false
                })));
        }
    }, [
        isHidden
    ]);
    const isAnyFiltered = tagsKeyFilter !== null || institutionKeyFilter !== null || q !== null;
    const isKeywordsSearched = keywordOthers && keywordOthers.length ? keywordOthers.find((a)=>a.active == true)?.name : null;
    const isKeywordActive = keywordOthers.find((a)=>a.active == true);
    const handleClickClose = ()=>{
        setKeywordOthers(keywordOthers.map((el)=>({
                ...el,
                active: false
            })));
        onReset();
        router.push({
            pathname: "/"
        }, undefined, {
            shallow: true
        });
    };
    const [isEmptyCourse, setIsEmptyCourse] = (0,react.useState)(true);
    const [isLoading, setIsLoading] = (0,react.useState)(true);
    const { setAllCourse , allCourse  } = (0,courseStore/* useCourseStore */.Kt)((c)=>({
            setAllCourse: c.setAllCourse,
            allCourse: c.allCourse
        }));
    const getAllCourse = async ()=>{
        try {
            const courseData = await (0,course/* getAllCoursesFromIndexedDB */.hN)();
            if (courseData.length > 0) {
                if (currentUser.email === courseData[0].user.email) {
                    setAllCourse(courseData);
                    setIsEmptyCourse(false);
                }
                ;
            }
        } catch (error) {
            ;
        } finally{
            setIsLoading(false);
        }
    };
    const downloadedCourse = allCourse?.map((course)=>{
        const { data  } = course;
        return {
            ...data
        };
    });
    (0,react.useEffect)(()=>{
        if (currentUser) {
            getAllCourse();
        }
    }, [
        currentUser
    ]);
    //
    const [driverAccess, setDriverAccess] = (0,react.useState)([]);
    const [isDriver, setIsDriver] = (0,react.useState)(false);
    const [previewCourse, setPreviewCourse] = (0,react.useState)(null);
    const setRecommendData = (0,searchStore/* useSearchStore */.R)((state)=>state.setRecommendData);
    const [tempData, setTempData] = (0,react.useState)(null);
    const accessCourseApi = (0,exploreApi/* useAccessCourseTenant */.le)();
    const institutionNames = typeof router.query.institutionKey == "string" && router.query.institutionKey ? router.query.institutionKey.split(",") : [];
    ;
    const institutionKeyFilter2 = institutionNames.length ? `${institutionNames.map((ins)=>`institution:"${ins}"`).join(" OR ")}` : "";
    const tagsNames = typeof router.query.tagsKey == "string" && router.query.tagsKey ? router.query.tagsKey.split(",") : [];
    ;
    const tagsKeyFilter2 = tagsNames.length ? `${tagsNames.map((ins)=>`tags:"${ins}"`).join(" OR ")}` : "";
    const sortByFilter2 = typeof router.query.sortBy == "string" ? router.query.sortBy : "";
    // useEffect(() => {
    //   console.log(driverAccess);
    // }, [driverAccess]);
    // const getCourseRecommend = (idxName) => {
    //   fetch(idxName ? `/api/search-algolia?indexName=${idxName}` : "/api/search")
    //     .then((res) => res.json())
    //     .then((res) => {
    //       const data =
    //         ArrayObjectSortBy(res.data?.hits, "created_date", true) ?? [];
    //       const recommendCourses = data.slice(0, 4);
    //       if (recommendCourses.length) {
    //         setRecommendData(recommendCourses);
    //       }
    //     });
    // };
    const isBlueBirdTenant =  true && ((0,host/* isBlueBirdURL */.TJ)(window.location.hostname) || (0,host/* isSubdomainBluebird */.ok)(window.location.hostname));
    const [nonSectionSliceCount, setNonSectionSliceCount] = (0,react.useState)({
        slice_1: 0,
        slice_2: 0,
        slice_3: 0
    });
    (0,react.useEffect)(()=>{
        setNonSectionSliceCount((prev)=>{
            const newSlice1 = Math.floor(Math.random() * 3) + 1;
            const newSlice2 = newSlice1 + Math.floor(Math.random() * 3) + 1;
            const newSlice3 = newSlice2 + Math.floor(Math.random() * 3) + 1;
            return {
                ...prev,
                slice_1: newSlice1,
                slice_2: newSlice2,
                slice_3: newSlice3
            };
        });
    }, [
        currentUser
    ]);
    const generateSequentialArray = (num)=>{
        return Array.from({
            length: num
        }, (_, i)=>i + 1);
    };
    // Bundles
    const getBundles = (0,bundleApi/* useGetBundleByTenantSlug */.mK)();
    const [bundles, setBundles] = (0,react.useState)([]);
    const [isLoadingBundles, setIsLoadingBundles] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (referral) {
            setIsLoadingBundles(true);
            getBundles.doFetch({
                slug: referral
            }, {
                onSuccess (res) {
                    setBundles(res?.data);
                    setIsLoadingBundles(false);
                },
                onError (err) {
                    const error = err.getActualType();
                    ;
                    setIsLoadingBundles(false);
                }
            });
        }
    }, [
        referral
    ]);
    // End Bundles
    const { renderingStep , setRenderingStep  } = (0,homeStore/* useHomeStore */.o)();
    (0,react.useEffect)(()=>{
        ;
    }, [
        renderingStep
    ]);
    const courseRef = (0,react.useRef)(null);
    const courseContinueRef = (0,react.useRef)(null);
    const filterRef = (0,react.useRef)(null);
    const keywordsRef = (0,react.useRef)(null);
    const headerRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (courseRef.current && renderingStep <= 2) {
            setRenderingStep(2);
            setTimeout(()=>{
                if (loginState === "NOT_LOGIN" || !isDesktop || onGoingCourses.length === 0) {
                    setRenderingStep(3);
                }
            }, 1500);
        }
    }, [
        courseRef.current,
        renderingStep,
        loginState,
        isDesktop,
        onGoingCourses
    ]);
    (0,react.useEffect)(()=>{
        if (courseContinueRef.current && renderingStep <= 3) {
            setRenderingStep(3);
        }
    }, [
        courseContinueRef.current,
        renderingStep
    ]);
    (0,react.useEffect)(()=>{
        if (filterRef.current && renderingStep <= 4) {
            setRenderingStep(4);
        }
    }, [
        filterRef.current,
        renderingStep
    ]);
    (0,react.useEffect)(()=>{
        if (keywordsRef.current && renderingStep <= 5) {
            setRenderingStep(5);
        }
    }, [
        keywordsRef.current,
        renderingStep
    ]);
    (0,react.useEffect)(()=>{
        if (headerRef.current && renderingStep <= 6) {
            setRenderingStep(6);
        }
    }, [
        headerRef.current,
        renderingStep
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        children: [
            isHidden || renderingStep >= 5 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeaderDesktop/* PageHeaderDesktop */._, {
                headerRef: headerRef,
                onChangeSearch: debouncedOnChange
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonWrapper */.nR, {
                className: "flex justify-between items-center",
                children: skeletonHeader.map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                        className: "h-[67px] rounded-8 w-full m-20"
                    }, el))
            }),
            currentUser && isShowTawkTo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(tawk_messenger_react_es/* default */.Z, {
                propertyId: tawkPropertyId,
                widgetId: tawkWidgetId,
                onChatMinimized: onChatMinimized,
                onChatMaximized: onChatMaximized,
                onChatMessageVisitor: onChatMessageVisitor,
                onFileUpload: onFileUpload,
                onLoad: onLoad,
                ref: tawkMessengerRef
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                isBottom: isMobile,
                top: !isMobile ? "5vh" : "0",
                closeModal: ()=>submitPreference(true),
                zIdx: 999,
                show: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: `bg-white md:w-[50vw] w-[100vw] rounded-16 ${isMobile ? "rounded-b-0" : ""}`,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between p-24",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-black text-b1 font-medium",
                                    children: "Pilih Preferensi"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cursor-pointer",
                                    onClick: ()=>{
                                        // @ts-ignore
                                        (0,amplitude/* trackEvent */.L9)({
                                            event: "myinterest_close_a"
                                        });
                                        submitPreference(true);
                                        setShowKYC(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* default */.Z, {
                                        color: "#5D586C",
                                        size: 20
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(KYC, {
                            competencesKYC: competencesKYC,
                            handleTagClick: handleTagClick,
                            selectedKYCTags: selectedKYCTags,
                            submitPreference: submitPreference,
                            isLoading: userPreferenceApi.isLoading
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `min-h-[80vh]`,
                children: [
                    !isMobileView && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "courses",
                        className: "continue-course",
                        children: (myClassAPI.isLoading || onGoingCourses.length > 0) && !sortByFilter && !isAnyFiltered && loginState == "LOGIN" && !isKeywordsSearched && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "px-16 md:px-20 py-16 overflow-hidden",
                            children: !myClassAPI.isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex justify-between items-center mb-8 lg:mb-16",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: {
                                                    pathname: "/my-class"
                                                },
                                                onClick: ()=>{
                                                    (0,amplitude/* trackEventGTM */.hk)({
                                                        event: "b2b_homepage_course_more_a",
                                                        property: {
                                                            button_type: "Section Title",
                                                            section: 0,
                                                            category_name: `Continue Your Course`
                                                        }
                                                    });
                                                    (0,amplitude/* trackEventGA */.w7)({
                                                        event: "b2b_homepage_course_more_a",
                                                        property: {
                                                            button_type: "Section Title",
                                                            section: 0,
                                                            category_name: `Continue Your Course`
                                                        }
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "text-h4 text-purple80_to_dark10 font-medium",
                                                    children: continueYourCourses + `${onGoingCourses.length > 1 && continueYourCourses.includes("Continue") ? "s" : ""}`
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: {
                                                    pathname: "/my-class"
                                                },
                                                onClick: ()=>{
                                                    (0,amplitude/* trackEventGTM */.hk)({
                                                        event: "b2b_homepage_course_more_a",
                                                        property: {
                                                            button_type: "",
                                                            section: 0,
                                                            category_name: `Continue Your Course`
                                                        }
                                                    });
                                                    (0,amplitude/* trackEventGA */.w7)({
                                                        event: "b2b_homepage_course_more_a",
                                                        property: {
                                                            button_type: "",
                                                            section: 0,
                                                            category_name: `Continue Your Course`
                                                        }
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "text-b2 lg:text-b1 text-violet_main_to_dark_purple_surface font-medium cursor-pointer",
                                                    children: t("viewAll")
                                                })
                                            })
                                        ]
                                    }),
                                    (renderingStep >= 2 || isHidden) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: courseContinueRef,
                                        className: `flex gap-x-16 overflow-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] ${onGoingCourses.length < 3 ? "justify-start" : "justify-between"}`,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_CardContinue, {
                                            onGoingCourses: onGoingCourses
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonWrapper */.nR, {
                                className: "grid grid-cols-3 gap-x-20",
                                children: skeleton.map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                        className: "h-[138px] rounded-8 w-full"
                                    }, el))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* ContainerDesktop */.h, {
                        className: tagsKeyFilter !== "" || institutionKeyFilter !== "" ? "pb-0" : "pb-24",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: `flex md:grid md:grid-cols-6 gap-40`,
                            children: [
                                isHidden || renderingStep >= 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: filterRef,
                                    className: "h-fit sticky z-10 top-[72px] bg-white md:bg-transparent max-w-[300px] hidden rounded-12 md:block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTenant, {
                                        dataCompetences: competencesFilter,
                                        onReset: onReset,
                                        filters: filters,
                                        sortDesc: sortDesc,
                                        currentSort: {
                                            ...currentSort
                                        },
                                        // update reset keywords when any filter selected
                                        setSortByDesc: (a)=>{
                                            setSortByDesc(a);
                                            setKeywordOthers(keywordOthers.map((el)=>({
                                                    ...el,
                                                    active: false
                                                })));
                                        },
                                        setFilters: (a)=>{
                                            setFilters(a);
                                            setKeywordOthers(keywordOthers.map((el)=>({
                                                    ...el,
                                                    active: false
                                                })));
                                        },
                                        onSetCurrentSort: (a)=>{
                                            setCurrentSort({
                                                ...currentSort,
                                                a
                                            });
                                            setKeywordOthers(keywordOthers.map((el)=>({
                                                    ...el,
                                                    active: false
                                                })));
                                        }
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonWrapper */.nR, {
                                    className: "h-fit sticky z-10 top-[72px] bg-white md:bg-transparent max-w-[300px] hidden rounded-12 md:block",
                                    children: skeletonFilter.map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                            className: "h-[135px] rounded-8 w-full my-10"
                                        }, el))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-span-5 home-tenant",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex pt-8 px-[16px]",
                                            children: [
                                                !isSearchPage && (totalFilter > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    onClick: openModal,
                                                    // sticky top-[72px] z-10
                                                    className: "md:hidden bg-white py-16 w-full cursor-pointer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "px-16 py-8 bg-light_neutral10_to_dark_neutral50 rounded-20 border border-violet_main ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center justify-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFilter/* IconFilter */.w, {
                                                                    color: "#883CFF"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-violet_main_to_dark_purple_surface font-medium text-b2 ml-8",
                                                                    children: "Filter"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "ml-8 px-4 bg-violet_main_to_dark_purple_surface text-white rounded-full text-c1",
                                                                    children: totalFilter
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: `md:hidden border rounded-full cursor-pointer px-12 py-8 text-center flex items-center m-8 ml-0 text-c1 font-medium border-neutral-40 text-neutral-70`,
                                                    onClick: openModal,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFilter/* IconFilter */.w, {})
                                                })),
                                                isMobileView && keywordOthers.length > 0 && !isHidden && renderingStep >= 4 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    ref: keywordsRef,
                                                    className: "flex overflow-x-auto hide-scrollbar",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_Keywords, {
                                                        setDataPaginate: setDataPaginate,
                                                        pageKeywords: pageKeywords,
                                                        setPageKeywords: setPageKeywords,
                                                        hasNextPage: hasNextPage,
                                                        setHasNextPage: setHasNextPage,
                                                        isLoadingKeywords: isLoadingKeywords,
                                                        setIsLoadingKeywords: setIsLoadingKeywords,
                                                        itemsPerPage: itemsPerPage,
                                                        keywordOthers: keywordOthers,
                                                        onReset: onReset,
                                                        setKeywordOthers: setKeywordOthers,
                                                        setCoursesAfterClicked: setCoursesAfterClicked
                                                    })
                                                }) : null
                                            ]
                                        }),
                                        !isMobileView && keywordOthers.length > 0 && !isHidden && renderingStep >= 4 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            ref: keywordsRef,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_Keywords, {
                                                setDataPaginate: setDataPaginate,
                                                pageKeywords: pageKeywords,
                                                setPageKeywords: setPageKeywords,
                                                hasNextPage: hasNextPage,
                                                setHasNextPage: setHasNextPage,
                                                isLoadingKeywords: isLoadingKeywords,
                                                setIsLoadingKeywords: setIsLoadingKeywords,
                                                itemsPerPage: itemsPerPage,
                                                keywordOthers: keywordOthers,
                                                onReset: onReset,
                                                setKeywordOthers: setKeywordOthers,
                                                setCoursesAfterClicked: setCoursesAfterClicked
                                            })
                                        }) : null,
                                        !isKeywordActive && !isHidden && bundles.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: !isDesktop && "px-16",
                                            ref: courseRef,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_SectionBundles, {
                                                bundles: bundles,
                                                section: null,
                                                isHidden: isHidden || isKeywordsSearched
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            ref: courseRef,
                                            className: "px-16",
                                            children: isMobileView && sectionsMandatory.length > 0 && !isHidden && !isKeywordActive ? sectionsMandatory.map((s, idx)=>{
                                                // console.log(s);
                                                return /*#__PURE__*/ (0,react.createElement)(Tenant_SectionMandatory, {
                                                    ...s,
                                                    key: s.id,
                                                    section: idx,
                                                    isHidden: isHidden || isKeywordsSearched
                                                });
                                            }) : null
                                        }),
                                        referral && referral !== "interagroup" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: `${isHidden || isKeywordsSearched ? "hidden" : ""}`,
                                            children: [
                                                currentUser && isMobileView && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserRecomendations, {
                                                    sliced: true,
                                                    startSlice: 0,
                                                    endSlice: nonSectionSliceCount.slice_1,
                                                    isSquare: true
                                                }),
                                                allCourse?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    ref: courseRef,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_Section, {
                                                        data: downloadedCourse,
                                                        tag: null,
                                                        title: "Kursus Terdownload",
                                                        // title={"sectionPopular"}
                                                        section: 1,
                                                        emoji: "",
                                                        id: null,
                                                        isHidden: isHidden || isKeywordsSearched
                                                    })
                                                }),
                                                isBlueBirdTenant ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        currentUser?.profile?.position == "Driver" && driverAccess.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            ref: courseRef,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_Section, {
                                                                data: driverAccess,
                                                                tag: null,
                                                                title: "Kursus untuk Driver",
                                                                // title={"sectionPopular"}
                                                                section: 2,
                                                                emoji: "",
                                                                id: null,
                                                                isHidden: isHidden || isKeywordsSearched
                                                            })
                                                        }),
                                                        sectionsMandatory.length > 0 ? sectionsMandatory.map((s, idx)=>{
                                                            // console.log(s);
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                ref: courseRef,
                                                                children: /*#__PURE__*/ (0,react.createElement)(Tenant_SectionMandatory, {
                                                                    ...s,
                                                                    key: s.id,
                                                                    section: idx,
                                                                    isHidden: isHidden || isKeywordsSearched
                                                                })
                                                            });
                                                        }) : null
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                isDesktop && (sectionsMandatory.length > 0 ? sectionsMandatory.map((s, idx)=>{
                                                    // console.log(s);
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        ref: courseRef,
                                                        children: /*#__PURE__*/ (0,react.createElement)(Tenant_SectionMandatory, {
                                                            ...s,
                                                            key: s.id,
                                                            section: idx,
                                                            isHidden: isHidden || isKeywordsSearched
                                                        })
                                                    });
                                                }) : null),
                                                sectionPosition.length > 0 ? // If want to load from API, activate the
                                                // useEffect "Sort section based on sectionPosition"
                                                // and use SectionB2B only
                                                sectionPosition.map((s, idx)=>{
                                                    // console.log(s);
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "px-16 md:px-0",
                                                        ref: courseRef,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_Section, {
                                                            // tag={s.tag.name}
                                                            id: s.id,
                                                            tag: s.tag.name,
                                                            title: s.title,
                                                            section: idx,
                                                            emoji: s.emoji,
                                                            sort: null,
                                                            data: s.tag.courses,
                                                            isNeedFetchCourse: false,
                                                            isHidden: isHidden || isKeywordsSearched
                                                        }, s.title)
                                                    });
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "px-16 md:px-0",
                                                    children: sectionPosition.length > 0 && sectionB2B.length > 0 ? sectionB2B.slice(0, 1).map((s, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            ref: courseRef,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_Section, {
                                                                id: "default",
                                                                tag: s.tag,
                                                                title: s.title,
                                                                section: idx,
                                                                emoji: s.emoji,
                                                                isHidden: isHidden || isKeywordsSearched
                                                            }, s.id)
                                                        })) : null
                                                }),
                                                currentUser && isMobileView && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserRecomendations, {
                                                    sliced: true,
                                                    startSlice: nonSectionSliceCount.slice_1,
                                                    endSlice: nonSectionSliceCount.slice_2,
                                                    isSquare: true
                                                }),
                                                isMobileView && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    id: "courses",
                                                    className: "continue-course mb-[24px]",
                                                    children: (myClassAPI.isLoading || onGoingCourses.length > 0) && !sortByFilter && !isAnyFiltered && loginState == "LOGIN" && !isKeywordsSearched && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "px-16 md:px-20 py-16 overflow-hidden",
                                                        children: !myClassAPI.isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex justify-between items-center mb-8 lg:mb-16",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: {
                                                                                pathname: "/my-class"
                                                                            },
                                                                            onClick: ()=>{
                                                                                (0,amplitude/* trackEventGTM */.hk)({
                                                                                    event: "b2b_homepage_course_more_a",
                                                                                    property: {
                                                                                        button_type: "Section Title",
                                                                                        section: 0,
                                                                                        category_name: `Continue Your Course`
                                                                                    }
                                                                                });
                                                                                (0,amplitude/* trackEventGA */.w7)({
                                                                                    event: "b2b_homepage_course_more_a",
                                                                                    property: {
                                                                                        button_type: "Section Title",
                                                                                        section: 0,
                                                                                        category_name: `Continue Your Course`
                                                                                    }
                                                                                });
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                className: "text-h4 text-purple80_to_dark10 font-medium",
                                                                                children: continueYourCourses + `${onGoingCourses.length > 1 && continueYourCourses.includes("Continue") ? "s" : ""}`
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: {
                                                                                pathname: "/my-class"
                                                                            },
                                                                            onClick: ()=>{
                                                                                (0,amplitude/* trackEventGTM */.hk)({
                                                                                    event: "b2b_homepage_course_more_a",
                                                                                    property: {
                                                                                        button_type: "",
                                                                                        section: 0,
                                                                                        category_name: `Continue Your Course`
                                                                                    }
                                                                                });
                                                                                (0,amplitude/* trackEventGA */.w7)({
                                                                                    event: "b2b_homepage_course_more_a",
                                                                                    property: {
                                                                                        button_type: "",
                                                                                        section: 0,
                                                                                        category_name: `Continue Your Course`
                                                                                    }
                                                                                });
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                className: "text-b2 lg:text-b1 text-violet_main_to_dark_purple_surface font-medium cursor-pointer",
                                                                                children: t("viewAll")
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                (renderingStep >= 2 || isHidden) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    ref: courseContinueRef,
                                                                    className: `flex gap-x-16 overflow-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] ${onGoingCourses.length < 3 ? "justify-start" : "justify-between"}`,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_CardContinue, {
                                                                        onGoingCourses: onGoingCourses
                                                                    })
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonWrapper */.nR, {
                                                            className: "grid grid-cols-3 gap-x-20",
                                                            children: skeleton.map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                                                    className: "h-120 rounded-8 w-full"
                                                                }, el))
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "px-16 md:px-0",
                                                    children: sectionPosition.length > 0 && sectionB2B.length > 0 ? sectionB2B.slice(1, 2).map((s, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            ref: courseRef,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_Section, {
                                                                id: "default",
                                                                tag: s.tag,
                                                                title: s.title,
                                                                section: idx,
                                                                emoji: s.emoji,
                                                                isHidden: isHidden || isKeywordsSearched
                                                            }, s.id)
                                                        })) : null
                                                }),
                                                currentUser && isMobileView && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserRecomendations, {
                                                    sliced: true,
                                                    startSlice: nonSectionSliceCount.slice_2,
                                                    endSlice: nonSectionSliceCount.slice_3,
                                                    isSquare: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    ref: courseRef,
                                                    className: "px-16 md:px-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_Section, {
                                                        tag: "newest",
                                                        title: "sectionNew",
                                                        section: 98,
                                                        sort: "created_date",
                                                        emoji: "",
                                                        id: null,
                                                        isHidden: isHidden || isKeywordsSearched
                                                    }, "Kursus Terbaru")
                                                }),
                                                isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserRecomendations, {
                                                    isLast: true
                                                }),
                                                isMobileView && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserRecomendations, {
                                                    sliced: true,
                                                    startSlice: nonSectionSliceCount.slice_3,
                                                    isSquare: true,
                                                    isLast: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "hidden md:flex md:flex-col",
                                            children: coursesAfterKeywordClicked.length > 0 && !q && isKeywordsSearched ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                ref: courseRef,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_HomeCardKeywords, {
                                                    dataPaginate: dataPaginate,
                                                    pageKeywords: pageKeywords,
                                                    setPageKeywords: setPageKeywords,
                                                    hasNextPage: hasNextPage,
                                                    setHasNextPage: setHasNextPage,
                                                    isLoadingKeywords: isLoadingKeywords,
                                                    setIsLoadingKeywords: setIsLoadingKeywords,
                                                    itemsPerPage: itemsPerPage,
                                                    startIndex: startIndex,
                                                    data: coursesAfterKeywordClicked,
                                                    isKeywordsSearched: isKeywordsSearched,
                                                    keywordOthers: keywordOthers,
                                                    isSquare: false,
                                                    handleReset: handleClickClose,
                                                    setCoursesAfterClicked: setCoursesAfterClicked
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                ref: courseRef,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_HomeCard, {
                                                    data: coursesAfterKeywordClicked,
                                                    sections: sectionB2B.length,
                                                    filters: filters,
                                                    searchText: searchText,
                                                    sortDesc: sortDesc,
                                                    textValue: textValue,
                                                    isSquare: false,
                                                    isHidden: isHidden || !isKeywordsSearched,
                                                    isKeywordsSearched: isKeywordsSearched,
                                                    handleReset: handleClickClose
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                                            show: true,
                                            isFull: true,
                                            isBottom: true,
                                            zIdx: 999,
                                            closeModal: ()=>setShow(!show),
                                            hide: show,
                                            children: (isHidden || renderingStep >= 3) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                ref: filterRef,
                                                className: "shadow-filter bg-white pr-2 rounded-t-12 md:rounded-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTenant, {
                                                    dataCompetences: competencesFilter,
                                                    onReset: onReset,
                                                    setFilters: setFilters,
                                                    filters: filters,
                                                    sortDesc: sortDesc,
                                                    setSortByDesc: setSortByDesc,
                                                    currentSort: {
                                                        ...currentSort
                                                    },
                                                    onSetCurrentSort: (a)=>setCurrentSort({
                                                            ...currentSort,
                                                            a
                                                        }),
                                                    closeModal: ()=>setShow(!show)
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "block md:hidden",
                        children: isKeywordsSearched && coursesAfterKeywordClicked.length && !q ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: courseRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_HomeCardKeywords, {
                                dataPaginate: dataPaginate,
                                pageKeywords: pageKeywords,
                                setPageKeywords: setPageKeywords,
                                hasNextPage: hasNextPage,
                                setHasNextPage: setHasNextPage,
                                isLoadingKeywords: isLoadingKeywords,
                                setIsLoadingKeywords: setIsLoadingKeywords,
                                itemsPerPage: itemsPerPage,
                                startIndex: startIndex,
                                data: coursesAfterKeywordClicked,
                                isKeywordsSearched: isKeywordsSearched,
                                keywordOthers: keywordOthers,
                                isSquare: true,
                                handleReset: handleClickClose,
                                setCoursesAfterClicked: setCoursesAfterClicked
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: courseRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tenant_HomeCard, {
                                sections: sectionB2B.length,
                                filters: filters,
                                searchText: searchText,
                                sortDesc: sortDesc,
                                textValue: textValue,
                                isSquare: true,
                                isHidden: isHidden || !isKeywordsSearched,
                                isKeywordsSearched: isKeywordsSearched,
                                handleReset: handleClickClose
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalSectionsDetail/* default */.Z, {})
        ]
    });
};


/***/ })

}]);